// COCHE §10.1.10 — Simplified Chinese (default). Add new keys here first;
// the LocaleSwitcher writes "imles-locale" to localStorage and that drives
// vue-i18n at runtime. Server-side schema labels are localised separately
// via the X-Imles-Locale header → Jackson modifier swap.
export default {
	common: {
		save: "保存",
		cancel: "取消",
		delete: "删除",
		edit: "编辑",
		search: "搜索",
		export: "导出",
		import: "导入",
		confirm: "确定",
		yes: "是",
		no: "否",
		add: "新增",
		back: "返回",
		close: "关闭",
		operation: "操作",
		loading: "加载中…",
		empty: "暂无数据",
		opSuccess: "操作成功",
		opFailed: "操作失败",
		submit: "提交",
		reset: "重置",
		reload: "刷新",
		view: "查看",
		more: "更多",
		all: "全部",
		tip: "提示",
		confirmDelete: "确认是否删除?",
		pleaseSelect: "请选择",
		loadFailed: "加载失败",
		downloadSuccess: "下载成功",
		warning: "警告",
		operationSuccess: "操作成功",
		pleaseInput: "请输入",
		deleteSuccess: "删除成功",
		editSuccess: "编辑成功",
		addSuccess: "新增成功",
		viewSource: "溯源",
		confirmDeleteRecord: "确定删除当前记录？",
		recordSeqHeader: "序号",
		detail: "详情",
		requiredFieldHint: "缺少必填项，再次点击提交定位到输入框",
	},
	auth: {
		sessionExpired: "登录已过期，请重新登录。",
		permissionDenied: "您没有执行此操作的权限。",
		networkError: "无法连接服务器，请检查网络。",
		serverUnavailable: "服务暂时不可用，请稍后重试。",
	},
	login: {
		title: "登录",
		username: "用户名",
		password: "密码",
		submit: "登录",
		captcha: "验证码",
		rememberMe: "记住我",
		welcome: "欢迎登录",
		signIn: "登录",
		platformTitle: "科研数据库平台",
		platformTagline: "高效采集、灵活易用的临床科研数据解决方案",
		sxswTitle: "陕西省神经外科医疗质量控制中心数据填报系统",
		bgAlt: "背景图",
		tabPassword: "密码登录",
		tabSms: "验证码登录",
		tabWechat: "微信扫码登录",
		usernamePh: "请输入账号",
		passwordPh: "请输入密码",
		mobilePh: "请输入手机号",
		smsCodePh: "请输入短信验证码",
		captchaPh: "图形验证码",
		invalidMobile: "请输入11位有效手机号",
		getCode: "获取验证码",
		resendCode: "{sec}秒后重新获取",
		smsSent: "获取验证码成功",
		copyright: "© 2026 北京医合易生科技有限公司. 京ICP备 19052789-1",
		icpFiling: "京公网安备11011302007191",
		platformTitleMycoach: "临床数据平台",
		platformTaglineMycoach: "Unlock Clinical Data",
		copyrightMycoach: "© 2026 Mycoach Health Limited. 保留所有权利。符合 HIPAA 与 PIPEDA 标准。",
	},
	nav: {
		dashboard: "工作台",
		patients: "患者",
		projects: "项目",
		schema: "模型",
		governance: "治理",
		settings: "设置",
		logout: "退出登录",
	},
	locale: {
		switcher: "语言",
		en_hk: "English",
		zh_hk: "繁體中文",
		zh_cn: "简体中文",
	},
	i18n: {
		schemaTranslate: {
			title: "模型多语言翻译",
			scanProject: "扫描项目缺失",
			draftWithLlm: "AI 起草",
			applySelected: "保存所选",
			columnSource: "原文",
			columnSuggestion: "AI 建议",
			columnEdited: "您的修改",
			noMissing: "该项目所有字段均已翻译。",
		},
	},
	imaging: {
		title: "影像查看器",
		subtitle: "COCHE Tier-B — B2 查看器 · B4 标注 (cvd_hk)",
		studies: "检查",
		series: "序列",
		viewer: "查看器",
		reload: "重新加载",
		loading: "加载中…",
		prev: "上一张",
		next: "下一张",
		workspace: "工作台",
		metadata: "元数据",
		task: "任务",
		noImaging: "该患者暂无影像",
		selectSeries: "请选择序列",
		layersShort: "图层",
		frame: "帧",
		slice: "层",
		phase: "时相",
		axial: "横断",
		coronal: "冠状",
		sagittal: "矢状",
		play: "播放",
		pause: "暂停",
		playHint: "空格键播放／暂停 · ← → 相位 · ↑ ↓ 层面",
		localBuffer: "本地缓存",
		bufferLoading: "已加载 {n}/{total} 个{unit}…",
		bufferDone: "全部 {n} 个{unit}已加载 ✓",
		bufferLayers: "含 {n} 个标注层",
		wlAuto: "自动",
		display: "显示",
		brightness: "亮度",
		contrast: "对比度",
		wlCtSoft: "CT 软组织（400/40）",
		wlCtLung: "CT 肺窗（1500/−600）",
		wlCtBone: "CT 骨窗（2000/300）",
		wlCtBrain: "CT 脑窗（80/40）",
		wlCtVascular: "CT 血管（600/150）",
		wlBrighter: "更亮",
		wlDarker: "更暗",
		wlContrastHi: "高对比",
		wlContrastLo: "柔和",
		wlFullRange: "全范围",
		wlCustom: "自定义",
		zoom: "缩放",
		reset: "重置",
		aiSegment: "AI 分割",
		segDialogTitle: "AI 分割 — 需要哪些结构？",
		toolGrow3d: "3D 生长",
		segPhase: "相位",
		segPhaseHint: "将堆栈中的一个回波／b 值作为体数据分割",
		segOffNotVolume: "AI 分割需要三维体积数据；此为 {n} 张独立影像的二维序列。请改用画笔、多边形或区域生长描绘。",
		segOffRole: "此序列属扫描器辅助影像而非诊断采集——按设计不纳入 AI 分割。",
		structureLabel: "标签",
		resolveNoPermission: "您的角色可裁决任务但不可创建任务——此分权为刻意设计。请由管理员或上传者就本序列创建任务；系统直接采用现有的两个图层，再由您裁决。",
		acceptAs: "采用 {who}",
		acceptHint: "由其中一人决定以哪一份为准。可撤回，并记录于该图层的历史中。",
		acceptNeedsSubmitted: "只有已完成的图层可被采用——请作者先标记完成。",
		acceptedOk: "图层 #{id} 已成为本序列的基准",
		referenceTag: "基准",
		referenceHint: "已就本序列采用。其余图层维持原状——不会删除任何内容。",
		withdrawReference: "撤回",
		resolveInTask: "以任务裁决 \u2192",
		resolveTitle: "裁决此分歧",
		resolveIntro: "任务才能让人作出决定。它直接采用现有的两个图层——无需重画——指定裁决者，并记录决定与金标准图层。",
		resolveReaders: "读片者",
		resolveLabels: "标签",
		resolveAdjHint: "由谁裁决——须为读片者以外的人方有意义",
		resolveCreate: "创建并裁决",
		resolveCreated: "已创建任务 #{id} \u00b7 {status}",
		resolveNeedsPair: "请选择由不同人绘制、且至少共用一个标签的两个图层。",
		agreementTitle: "读片者一致性",
		agreementSub: "本序列的两个图层，仅就双方共有的标签计分",
		agreementSameAuthor: "两个图层属同一作者——此为自我比较，并非读片者一致性。",
		agreementNoOverlap: "两个图层没有共同标签，无从计分。",
		agreementHint: "Dice 为重叠程度；kappa 为超出随机的一致程度。建立任务可纳入完整读片小组、裁决者与金标准图层。",
		meanDice: "平均 Dice",
		voxelsA: "体素 A",
		voxelsB: "体素 B",
		segBackend: "运算位置",
		segBackendLocal: "本机（CPU）",
		segBackendGpu: "GPU 节点（西安）",
		segBackendHint: "GPU 节点不会被自动选用——需明确选择；选用后若节点不可用即直接失败，不会退回 CPU，以免把 CPU 结果误认为 GPU 结果。",
		segQuality: "质量",
		segFull: "全分辨率",
		segFast: "快速（3 mm）",
		acrossSlices: "跨层面",
		keySlices: "个关键层",
		prevKey: "上一关键层",
		nextKey: "下一关键层",
		copyPrev: "← 复制到上一层",
		copyNext: "复制到下一层 →",
		interpolate: "在关键层之间插值",
		interpolated: "已填充 {n} 层",
		segTarget: "目标",
		segStructures: "个结构",
		segAllStructures: "模型已知的全部结构",
		segRun: "运行",
		measurements: "测量 — 来自 AI／金标准图层的结构体积",
		measDate: "日期",
		analysisTable: "分析表 — 每个结构一行",
		analysisTableShort: "分析表",
		scopePatientEyebrow: "患者",
		allPatients: "全部患者",
		refreshList: "刷新检查列表",
		scopeSeries: "当前序列",
		scopePatient: "整个患者",
		featLength: "范围 mm",
		role_diagnostic: "诊断序列",
		role_localizer: "定位像",
		cine_gated: "电影序列(门控)",
		cine_gated_stack: "电影序列组",
		cine_loop: "实时环放",
		cine_multiacq: "多次采集",
		cine_frames: "帧序列",
		cine_none: "",
		nonDicomHint: "非 DICOM——没有像素间距与采集元数据，测量以像素为单位，也没有可去标识的头信息。",
		role_calibration: "校准",
		role_radial: "放射状层块",
		role_fragment: "零散帧",
		role_derived: "衍生图",
		role_capture: "屏幕截图",
		analysisTableHint: "体积／管径／信号强度（× 为相对参考结构的比值），来自 AI、人工与金标准层；CSV 含全部列",
		downloadCsv: "CSV",
		featDiam: "最大径 mm",
		featIntensity: "信号",
		measSeries: "序列",
		measStructure: "结构",
		measSource: "来源",
		segStarted: "分割任务已在 {backend} 启动",
		saving: "保存中…",
		frameUnavailable: "帧不可用（像素未缓存）",
		layers: "图层",
		newLayer: "新建图层",
		noLayers: "尚无标注图层",
		opacity: "透明度",
		delete: "删除",
		deleteLayerConfirm: "删除图层 #{id}？此操作不可撤销。",
		tools: "绘制工具",
		toolNone: "浏览",
		toolBrush: "画笔",
		toolEraser: "橡皮",
		toolPolygon: "多边形",
		toolGrow: "区域生长",
		radius: "半径",
		tolerance: "容差",
		toolHint: "画笔/橡皮：拖动。多边形：点击顶点，双击闭合。区域生长：点击种子点。每一笔都保存到所选标签。平移：用「浏览」工具拖动，或随时按中键拖动；滚轮缩放。切换层面：‹ › 或 ↑ ↓。",
		undo: "撤销",
		redo: "重做",
		undoHint: "撤销此图层的上一次编辑（Ctrl+Z）",
		redoHint: "重做刚撤销的编辑（Ctrl+Shift+Z）",
		sliceBack: "上一层（↓）",
		sliceFwd: "下一层（↑）",
		sliceBack5: "后退 5 层",
		sliceFwd5: "前进 5 层",
		keyShort: "关键",
		acrossNone: "此平面尚未绘制 {label} — 先在任一{axis}画上。",
		acrossOne: "{label} 只有 1 个关键{axis}。移到另一{axis}画上，即可在两者之间插值。",
		acrossOffKey: "复制需从已有 {label} 的{axis}开始 — 用「◀ 关键 / 关键 ▶」跳到一个。",
		readOnlyLayer: "该图层只读（仅可编辑自己的草稿图层）。",
		submitReview: "提交审阅",
		submitHint: "任务 \u00b7 {title}",
		markDone: "\u2713 标注完成",
		markDoneHint: "冻结该图层作为您的完成稿，之后仍可重新开启。",
		markDoneConfirm: "将图层 #{id} 标记为完成？完成后变为只读，随时可重新开启继续编辑。",
		markDoneOk: "图层 #{id} 已标记完成",
		doneTag: "已完成",
		reopen: "重新开启编辑",
		reopenHint: "回到草稿状态以继续标注。",
		reopenedOk: "图层 #{id} 已重新开启",
		submitConfirm: "提交您的图层？提交后变为只读，所有读片者提交后自动计算一致性。",
		submitted: "已提交",
		phiRemoved: "入库时已去除的身份信息",
		studiesShort: "项检查",
		framesShort: "帧",
		filesShort: "个文件",
		metaSummary: "概要",
		metaDicom: "DICOM 头",
		notDicom: "非 DICOM 序列",
		filterTags: "筛选标签／属性／值",
		followFrame: "跟随当前帧",
		instance: "实例",
		reformatNote: "重建视图 — 显示第一个实例",
		tag: "标签",
		attribute: "属性",
		value: "值",
		chooseLabels: "选择标签",
		labelName: "标签名称",
		addLabel: "添加标签",
		presetPick: "选择一组 — 一键创建图层",
		presetNone: "该模态暂无对应组合 — 请在下方逐个选择",
		pickLabels: "或逐个选择标签",
		labelsForModality: "适用于 {modality}",
		labelsAll: "全部标签",
		labelsOther: "其他模态",
		labelNameHint: "标签名称，例如 左心室疤痕",
		labelCodeHint: "代码是永久键值 — 笔迹、一致性评分与导出均以它匹配。由名称自动生成，除非需要指定代码，否则无需修改。",
		cancel: "取消",
		create: "创建",
		assignedOnlyBadge: "您只看到分配给您的序列",
		assignedOnlyHint: "没有任务管理权限的成员只会看到自己作为标注者或裁决者的任务所属序列。",
		seriesNotVisible: "该序列未分配给您 — 已改为显示分配给您的序列。",
	},
	imagingWs: {
		size: "大小",
		title: "影像工作台",
		subtitle: "COCHE Tier-B — 检查 · 上传 · AI 分割任务 · 标注任务",
		noProject: "未选择项目 — 请从项目内打开，或在 URL 中加入 ?projectId=。",
		reload: "刷新",
		upload: "上传",
		purge: "清空项目影像数据",
		analysisCsv: "分析表 CSV",
		toAnalytics: "→ 科研分析数据集",
		toAnalyticsDone: "{rows} 行结构数据已登记为数据集 imaging_features v{version}",
		cpuOnly: "仅 CPU",
		gpuNotDefault: "已配置 GPU 节点，但不在自动路径上；如需使用，请在 AI 分割对话框中选择。",
		gpuUnreachable: "没有 GPU 节点响应；分割在本机执行。",
		stageGpu: "预载体积至 GPU 节点",
		stageGpuN: "GPU 预载 {staged}/{total}",
		stageStarted: "预载任务 #{id} 已启动，共 {n} 个体积",
		purgeConfirm: "删除本项目影像模块的全部检查、序列、标注和任务？此操作不可恢复。",
		purged: "已清除 {n} 个序列",
		tabStudies: "检查",
		tabJobs: "任务队列",
		tabTasks: "标注任务",
		patient: "患者",
		date: "日期",
		modality: "模态",
		description: "描述",
		seriesCount: "序列数",
		instances: "文件数",
		instancesHint: "DICOM SOP instance 即文件数：一个电影序列或分割对象是一个 instance，内含多帧。",
		series: "序列",
		frames: "帧数",
		kind: "类型",
		extent: "规模",
		role: "类别",
		annotations: "图层",
		actions: "操作",
		openViewer: "打开查看器",
		delete: "删除",
		deleted: "已删除",
		deleteConfirm: "删除“{name}”？此操作不可撤销。",
		uploadTitle: "上传影像（DICOM / NIfTI / 图片）",
		uploadDrop: "拖入文件夹、zip 或文件，或点击选择文件",
		uploadHint: "支持任意大小的 DICOM（文件夹、zip、DICOMDIR 导出——索引、报告与 RT 结构文件自动跳过；增强型多帧 MR / CT），以及 NIfTI、MP4 / AVI、PNG / JPEG。分 16 MB 段传输；入库时自动去除患者身份信息。",
		uploading: "上传中",
		uploadProgress: "{sent} / {total} · {rate}/s",
		uploadPart: "第 {n} / {m} 段 · 每段 16 MB，失败自动重试 3 次",
		uploadRetry: "已重试 {n} 次",
		uploadCancel: "取消上传",
		uploadCancelled: "上传已取消",
		etaMeasuring: "正在测速…",
		etaSoon: "不到 1 分钟",
		etaMinutes: "约剩 {n} 分钟",
		ingestSummary: "{accepted} 个入库 · {skipped} 个跳过 · {duplicate} 个已存在 · {rejected} 个拒绝",
		chooseFolder: "选择文件夹…",
		patientNoOpt: "患者编号（可选）",
		modalityOpt: "检查设备类型（非 DICOM）",
		modalityHint: "DICOM 自带设备类型；NIfTI、视频与图片文件没有。未声明时按“其他”入库，且不会进行 AI 分割，以免误用模型。",
		files: "个文件",
		clear: "清空",
		startUpload: "开始上传",
		close: "关闭",
		job: "任务",
		file: "文件",
		bytes: "大小",
		status: "状态",
		reason: "原因",
		backend: "后端",
		progress: "进度",
		createdBy: "创建人",
		started: "开始时间",
		duration: "耗时",
		error: "错误 / 结果",
		jobStarted: "任务 #{id} 已在 {backend} 启动",
		segmentTask: "模型",
		cancel: "取消",
		newTask: "新建标注任务",
		taskTitle: "标题",
		readers: "读片者",
		adjudicator: "仲裁者",
		threshold: "Dice 阈值",
		labels: "标签",
		assigneesHint: "逗号分隔的用户名，如 coche_researcher, coche_admin",
		create: "创建",
		created: "任务已创建 — 每位读片者一个草稿图层",
		open: "打开",
		adjudicate: "仲裁",
		adjudicationTitle: "标注仲裁",
		gold: "金标准",
		needTwoReaders: "该任务需要两个读片者图层才能仲裁。",
		readerA: "读片者 A",
		readerB: "读片者 B",
		diff: "差异",
		agree: "一致",
		only: "独有",
		jumpAnnotated: "跳到已标注帧",
		perLabelDice: "各标签一致性",
		raters: "位标注者",
		panelAgreement: "整体一致性",
		rater: "标注者",
		vsOthers: "与其他人的 Dice",
		acceptConsensus: "采纳 {n} 人共识为金标准",
		consensusHint: "多数投票：超过半数标注者标记的体素予以保留。",
		tabReaders: "标注者",
		readerStats: "标注者表现",
		readerStatsHint: "由图层、任务与编辑记录直接推导，无需额外维护。",
		statLayers: "图层数",
		statTasks: "任务数",
		statSubmitted: "已提交",
		statGold: "被采纳为金标准",
		statGoldRate: "采纳率",
		statEdits: "编辑次数",
		statDice: "与其他人的平均 Dice",
		statMinutes: "提交耗时中位数（分钟）",
		outcome: "结果",
		accepted: "已接受",
		duplicateN: "重复",
		skippedN: "跳过",
		rejectedN: "拒绝",
		alreadyHere: "已存在于：",
		history: "历史",
		historyTitle: "图层历史",
		historyEvents: "编辑记录",
		historyNone: "该图层暂无编辑记录。",
		historyFrom: "编辑自图层",
		historyDecision: "仲裁记录",
		staleLayer: "该图层在您绘制期间已被修改，正在重新加载；最后一笔未保存。",
		decision: "裁定",
		noteOpt: "备注（可选）",
		acceptA: "采纳 A 为金标准",
		acceptB: "采纳 B 为金标准",
		editA: "编辑 A → 金标准",
		editB: "编辑 B → 金标准",
		notDisputed: "任务状态为 {status} — 仅在争议状态下可裁定。",
		notAdjudicator: "仅仲裁者（{user}）可裁定该任务。",
		adjudicated: "已仲裁",
		goldLayer: "金标准图层",
		openInViewer: "在查看器中打开",
		assignedOnly: "标注者仅可见已分配的序列",
		assignedOnlyHint: "开启后，没有任务管理权限的成员只会看到自己作为标注者或裁决者的任务所属序列 — 检查列表、查看器及所有影像请求皆然。",
		assignedOnlyNoPermission: "仅任务管理者可更改。",
		assignedOnlyBadge: "您只看到分配给您的序列",
		settingSaved: "设置已保存",
		myTasks: "我的任务",
		myTasksHint: "您作为标注者或裁决者的任务",
		noTasksMine: "尚未有分配给您的任务",
		readersPick: "可标注的项目成员",
		adjudicatorPick: "可裁决的成员",
		aiReader: "AI 标注者（此序列最新的分割结果）",
		filterFrom: "起",
		filterTo: "止",
		filterSearch: "搜索描述 / 患者 / 检查号",
		filterRole: "序列角色",
		filterClear: "清除筛选",
		noMatch: "没有符合筛选条件的检查",
	},
	ml: {
		title: "联邦学习与模型注册",
		subtitle: "Flower FedAvg 跨站点训练——只有模型权重跨网传输，患者数据不出站点",
		taskTitle: "训练的是什么模型",
		taskHint: "跨网传输的只有这个共享模型本身",
		outcome: "预测结局",
		outcomeLabel: "三年内主要不良心血管事件（MACE），二分类",
		modelFamily: "模型",
		modelLabel: "逻辑回归，跨站点以 FedAvg 聚合",
		parameters: "参数量",
		coefPlural: "个系数",
		cohort: "各站点队列",
		cohortLabel: "每站点 {n} 例，由站点本地按自身随机种子生成，从不外传",
		variables: "预测变量",
		variable: "变量",
		unit: "单位",
		popDist: "人群均值 ± 标准差",
		coefficient: "全局系数",
		oddsRatio: "每 1 个标准差的 OR",
		intercept: "截距",
		standardisation: "各变量按固定的人群常数（而非各站点自身统计量）做 z 标准化，因此各站点的系数可直接比较。",
		finalModel: "最终模型",
		noCoef: "在下方选择一次训练任务即可查看学到的系数",
		feat: {
			age: "年龄",
			sbp: "收缩压",
			ldl: "低密度脂蛋白胆固醇",
			hba1c: "糖化血红蛋白",
			smoking: "吸烟",
			egfr: "估算肾小球滤过率 eGFR",
		},
		reload: "重新加载",
		startRun: "启动联邦训练",
		rounds: "轮",
		minClients: "最少站点数",
		liveRun: "训练进行中",
		runs: "联邦训练任务",
		noRuns: "暂无联邦训练任务",
		status: "状态",
		roundsDone: "轮次",
		sites: "站点",
		waitingClients: "等待站点接入…",
		bytes: "发送字节",
		auc: "AUC",
		loss: "损失",
		started: "开始时间",
		runDetail: "任务详情",
		live: "实时",
		rowsTransferred: "传输的数据行",
		wireTitle: "网络上实际传输的内容",
		wireHint: "每一条联邦消息的完整内容 —— 7 个 float32 模型权重，共 28 字节，不含任何患者数据行",
		wireValues: "权重",
		wireHex: "原始字节",
		direction: "方向",
		payload: "报文内容",
		globalToSites: "全局模型 → 各站点",
		toServer: "→ 服务器",
		site: "站点",
		city: "城市",
		jurisdiction: "司法辖区",
		nSamples: "样本数",
		joinCommand: "新站点接入命令",
		copy: "复制",
		copied: "已复制",
		chartTitle: "各站点每轮损失（实线）与全局模型 AUC（虚线）",
		round: "轮次",
		models: "模型注册表",
		noModels: "暂无已注册模型",
		name: "名称",
		version: "版本",
		algorithm: "算法",
		artifactSha: "制品 SHA-256",
		job: "任务",
		stage: "阶段",
		actions: "操作",
		toStaging: "预发布",
		toProduction: "发布到生产",
		strategy: "聚合方法",
		strategyParams: "方法参数",
		simulatedSites: "本机模拟站点",
		minClientsWarn: "所需站点数超过本机将启动的站点数",
		checkpoints: "检查点",
		checkpointsHint: "每一轮后的全局模型 — 可从任一轮恢复，或注册为模型",
		noCheckpoints: "尚无检查点",
		resumeFromHere: "从此处恢复",
		resumedFrom: "恢复自",
		resumeTitle: "恢复运行",
		resumeRounds: "运行轮数",
		stop: "停止",
		stopped: "运行已停止",
		registerCheckpoint: "注册",
		registered: "已注册",
		kind: "类型",
		kindFinal: "最终",
		kindCheckpoint: "检查点",
		download: "下载权重",
		compare: "比较",
		compareTitle: "模型比较",
		baseline: "基准",
		delta: "差值相对于基准",
		clearCompare: "清除",
		logs: "日志",
		logsTitle: "运行日志",
		noLogs: "此运行没有日志",
		cancel: "取消",
	},
	timeseries: {
		title: "生理信号",
		streams: "信号流",
		viewer: "查看器",
		reload: "重新加载",
		live: "实时",
		ingestRate: "写入速率",
	},
	interop: {
		title: "FHIR / OMOP 互操作",
		framing: "FHIR R4 导出层 / OMOP CDM v5.4 导出 — HAPI FHIR 服务器与 OHDSI ETL 为正式部署形态。",
		coverage: "映射覆盖率",
		fields: "个字段",
		mapped: "已映射",
		review: "待复核",
		unmapped: "未映射",
		perModel: "按模型",
		model: "模型",
		conceptMap: "概念映射表",
		field: "字段",
		target: "目标",
		resource: "资源 / 表",
		element: "元素 / 列",
		vocabulary: "术语集",
		code: "编码",
		conceptId: "OMOP concept_id",
		display: "显示名",
		unit: "单位",
		status: "状态",
		note: "备注",
		search: "搜索字段 / 编码 / 显示名",
		save: "保存",
		cancel: "取消",
		edit: "编辑",
		saved: "映射已保存",
		reseed: "重置为预设映射",
		reseedConfirm: "重新应用内置预设映射？手动修改将被覆盖。",
		lookup: "值级查找表",
		domain: "域",
		sourceValue: "来源值",
		fhir: "FHIR R4 Bundle",
		patient: "患者",
		pickPatient: "选择患者",
		viewBundle: "查看 FHIR Bundle",
		openRaw: "打开原始 $everything",
		validate: "验证整个项目",
		validating: "正在验证所有患者…",
		resources: "资源",
		valid: "有效",
		invalid: "无效",
		bundleValid: "Bundle 通过 fhir.resources R4B 验证",
		bundleInvalid: "Bundle 验证失败",
		omop: "OMOP CDM v5.4",
		download: "下载 OMOP CDM (zip)",
		preview: "预览数据表",
		rows: "行",
		table: "数据表",
		reload: "重新加载",
		loading: "加载中…",
		noProject: "请先选择项目",
		collapseAll: "全部折叠",
		expandAll: "全部展开",
	},
	encryption: {
		title: "加密状态",
		enabled: "已启用",
		disabled: "未启用",
		mysql: "MySQL",
		reload: "重新加载",
		encryptAll: "加密全部",
		decryptAll: "解密全部",
	},
	header: {
		maskedHospital: "****医院",
		systemAdminConsole: "系统管理控制台",
		switchTenant: "切换租户",
		configForm: "配置表单",
		switchProject: "切换项目",
		setPassword: "设置密码",
		changePassword: "修改密码",
		avatarSettings: "头像设置",
		settings: "设置",
		logout: "退出登录",
		oldPassword: "原密码",
		newPassword: "新密码",
		confirmPassword: "确认密码",
		enterOldPassword: "请输入原密码",
		enterNewPassword: "请输入新密码",
		enterConfirmPassword: "请再次输入新密码",
		passwordMismatch: "两次密码不一致",
		tenantCodePrompt: "输入租户编码(必须是正确的租户编码)",
		passwordSetSuccess: "密码设置成功, 请重新登录",
		passwordChangeSuccess: "密码修改成功, 请重新登录",
		compactMode: "紧凑模式",
		compactModeDesc: "表单字段横向排列，行距更紧凑",
		darkMode: "深色模式",
		darkModeDesc: "仅本机生效，刷新后保留",
		dataMasking: "数据脱敏",
		dataMaskingDesc: "在列表/表单中隐藏敏感字段",
		fontTheme: "字体主题",
		fontThemeDesc: "选择更现代的中英文字体组合，仅本机生效，立即应用",
		fontThemeModern: "现代",
		fontThemeEditorial: "严谨",
		fontThemeFriendly: "清新",
		betaSuffix: "（BETA）",
		languageDesc: "界面语言，切换后页面会自动刷新",
		changePasswordDesc: "更新登录密码，修改后需重新登录",
		avatarSettingsDesc: "上传或更换头像图片",
		modify: "修改",
		displayName: "显示名称",
		displayNameDesc: "应用中显示的名称；登录用户名不可更改",
		editDisplayName: "修改显示名称",
		displayNamePlaceholder: "请输入显示名称",
		displayNameRequired: "请输入显示名称",
		displayNameLength: "显示名称长度需为 1–120 个字符",
		displayNameUpdated: "显示名称已更新",
		sectionAccount: "账户",
		sectionAppearance: "外观",
		sectionPrivacy: "隐私",
	},
	followup: {
		title: "随访列表",
		statTotalCase: "病例总量",
		statMonthlyDue: "本月应到期访视",
		statMonthlyDone: "本月已完成访视",
		statMonthlyOpen: "本月未完成访视",
		searchDate: "随访日期：",
		searchStatus: "随访状态：",
		searchPatient: "患者姓名/编号：",
		startDate: "开始时间",
		endDate: "结束时间",
		select: "请选择",
		input: "请输入",
		searchBtn: "查 询",
		resetBtn: "重 置",
		colIndex: "序号",
		colVisitPlan: "访视计划预览",
		colPatientName: "患者姓名",
		colPatientNo: "患者编号",
		colVisitDate: "随访日期",
		colVisitName: "访视名称",
		colStatus: "随访状态",
		colCenter: "所属中心",
		colOperation: "操作",
		actEdit: "编辑",
		actView: "查看",
		actCancel: "取消随访",
		statusPending: "未随访",
		statusOverdue: "已超窗",
		statusDone: "已随访",
		fieldKeyword: "请输入关键字",
		detailTitle: "随访详情",
	},
	multicenter: {
		overviewTitle: "多中心概览",
		patientTitle: "多中心患者列表",
		followupTitle: "多中心随访管理",
		colCenter: "中心",
		colTenant: "租户",
		colPatientCount: "病例数",
		colFollowupCount: "随访数",
		colCompleteness: "完整度",
		switchProject: "切换项目",
		statCenters: "中心数量",
		statPatients: "患者总数量",
		statFollowups: "随访总次数",
		statOverdue: "过期未随访",
		newPatientTrend: "患者新增趋势",
		today: "今日",
		thisWeek: "本周",
		thisMonth: "本月",
		thisYear: "全年",
		startDate: "开始日期",
		endDate: "结束日期",
		dateSep: "至",
		centerPatientCount: "中心患者数量",
		colRank: "排名",
		colCenterName: "中心名称",
		colUserCount: "用户数",
		colPatientCountAlt: "患者数量",
		patientGender: "患者性别",
		mcInfo: "多中心信息",
		caseCount: "病例数",
		departmentCount: "科室",
		mapCenters: "多中心分布图",
		mapPatients: "患者区域分布图",
		caseFilter: "病例数量筛选",
		all: "ALL",
		hospitalName: "医院名称：",
		departmentName: "科室名称：",
		projectName: "项目名称：",
		patientCountLabel: "病例数量：",
		emptyData: "暂无数据",
	},
	manage: {
		auditLog: "审计日志",
		piiRule: "PII规则配置",
		governanceInbox: "审批收件箱",
		myRequests: "我的申请",
		scopeTree: "组织架构",
		lifecycle: "生命周期",
		metadataVersioning: "模型版本",
		ingestionHardening: "导入加固",
		ehealth: "eHealth 上传",
		subCenter: "分中心",
		schema: "架构生成",
		agentConfig: "Agent配置",
		random: "随机化",
		consent: "知情同意书",
	},
	databaseConfig: {
		patientBasicInfo: "患者基本信息配置",
		databaseSection: "数据库配置",
		followupSection: "随访表配置",
		colNo: "序号",
		colFormCode: "表单编码",
		colFormName: "表单名称",
		colModelCount: "模型数",
		colOp: "操作",
		colFollowupCode: "随访表单编号",
		colFollowupName: "随访表单名称",
		colFollowupPlan: "关联随访计划",
		colFollowupPlanName: "关联随访计划名称",
		btnAdd: "新增",
		btnBatchAdd: "批量新增",
		btnDelete: "删除",
		btnEdit: "编辑",
		btnConfig: "配置",
		btnConfigFromTemplate: "从模板配置",
		btnConfigFromForm: "从项目表单配置",
		dlgEditTitle: "编辑",
		dlgAddTitle: "新增",
		dlgEditFollowupTitle: "编辑随访表",
		dlgAddFollowupTitle: "新增随访表",
		dlgFormName: "表单名称",
		dlgFollowupName: "随访表单名称",
		dlgPh: "请输入",
		dlgCancel: "取消",
		dlgConfirm: "确定",
	},
	memberPermissions: {
		title: "人员权限",
		colNo: "序号",
		colTenant: "租户",
		colUsername: "用户名",
		colNickname: "昵称",
		colFuncPermission: "功能权限",
		colDataPermission: "数据权限",
		colActions: "操作",
		btnConfigure: "配置",
		btnEdit: "修改",
		noRolesAssigned: "（未分配角色）",
		scopeCount: "范围：{f} 个表单 · {m} 个模型",
		actEditRoles: "编辑功能权限",
		actEditData: "编辑数据权限",
		actRemove: "移除医生",
		confirmRemove: "确认移除当前医生?",
		dlgAddTitle: "多中心人员管理",
		addHint: "通过精确的用户名、工号或手机号搜索成员；添加后再在右侧表格中配置功能权限与数据权限。",
		searchPh: "请输入精确的 用户名/工号/手机号…",
		searchNoMatch: "未找到匹配的用户 — 请检查拼写或使用准确账号",
		lblAccount: "账号",
		btnAddAnother: "添加",
		dlgFuncTitle: "功能权限配置",
		projectRolesLabel: "项目范围内的角色（可在此编辑）",
		globalRolesLabel: "全局生效的角色（请在「用户管理」中编辑）",
		globalRolesHint: "这些角色是在用户层级分配的，对所有项目都生效。请在用户管理页中维护，本处仅作只读展示。",
		projectRolesEmptyButGlobal: "该用户尚未分配项目级角色，其在本项目的权限完全来自上方的全局角色。如需为本项目单独授权，请在此选择。",
		projectRolesEmptyNoGlobal: "该用户尚未分配任何角色，请在此选择以授予项目级权限。",
		dlgDataTitle: "数据权限配置",
		dataBypassModelAdmin: "提示：该用户拥有 Model Administrator 角色，会完全绕过数据权限过滤。下方的选择会被保存，但在浏览时不会生效——这些设置仅对没有 Model Administrator 角色的用户起作用。",
		dataBypassProjectCreator: "提示：该用户是本项目的创建人，会完全绕过数据权限过滤。下方的选择会被保存，但在浏览时不会生效——项目创建人始终可以看到全部表单与模型。",
		sodWarnTitle: "职责分离警告 ({n} 项冲突) — 仍可保存",
		sodErrorTitle: "职责分离冲突 ({n} 项) — 该项目已开启强制校验，无法保存",
		sodEnforceBlocked: "职责分离冲突 — 请移除冲突角色后再保存",
		sodWarnSaved: "已保存，但存在 {n} 项职责分离警告",
	},
	sod: {
		tagPending: "（待添加）",
		tagAssigned: "（已分配）",
		violationLine: "{a} 与 {b} 冲突 ({classA} × {classB})",
	},
	scopeTree: {
		filterTenantPh: "按租户筛选",
		visibilityTitle: "我的可见范围",
		visibilityPrompt: "点击『刷新』查询当前会话的可见项目集",
		fUserId: "用户 ID",
		fBypass: "绕过过滤",
		bypassYes: "是 (bypass)",
		bypassNo: "否 (enforced)",
		fReason: "原因 (reason)",
		fScopePaths: "Scope paths",
		noScopePath: "— 无 scope_path 分配 —",
		fAllowedProjects: "可见项目 ID",
		bypassAll: "— bypass: 全部可见 —",
		noVisibleProject: "无可见项目 (allowed-set is empty)",
		emptyTree: "暂无组织架构数据",
		rootLabel: "全部组织",
		tagDefault: "默认",
		tagProjectCount: "{n} 项目",
		truncated: "结果已截断 (>1000 节点)。请使用单层接口分页加载。",
		selectHint: "请在左侧选择一个节点以查看详情",
		dKind: "层级",
		dCode: "代码",
		dTenant: "租户",
		dRegulatory: "监管",
		dFederation: "联邦模式",
		dAddress: "地址",
		dCountry: "国家",
		dRegion: "地区",
		dMission: "使命",
		dProjectCount: "所含项目数",
	},
	auditLog: {
		title: "审计日志",
		refresh: "刷新",
		startDate: "起始时间",
		endDate: "结束时间",
		category: "分类",
		verb: "动作 (verb)",
		targetType: "目标类型",
		outcome: "结果",
		actorUserId: "操作人 ID",
		dataSubjectId: "数据主体 ID (GDPR)",
		targetProjectCode: "项目代码",
		search: "查询",
		reset: "重置",
		empty: "暂无审计日志",
		colTime: "时间",
		colActor: "操作人",
		colApp: "入口",
		colCategory: "分类",
		colVerb: "动作",
		colTarget: "目标",
		colOutcome: "结果",
		colDetail: "详情",
		view: "查看",
		drawerTitle: "审计日志详情",
		eventSection: "事件",
		complianceSection: "合规元数据 (GDPR readiness)",
		integritySection: "完整性 (hash chain)",
		fId: "ID",
		fTime: "时间",
		fActor: "操作人",
		fIp: "IP",
		fApp: "入口",
		fCategory: "分类 / 动作",
		fOutcome: "结果",
		fFailureReason: "失败原因",
		fTarget: "目标",
		fProject: "项目",
		fLawful: "lawful_basis",
		fSubject: "data_subject_id",
		fCrossBorder: "cross_border_transfer",
		yes: "是",
		no: "否",
		fDestCountry: "destination_country",
		fPrev: "prev_log_hash",
		fThis: "this_log_hash",
		changeRefSection: "关联变更记录",
		loadChange: "加载变更详情",
		fTable: "表/集合",
		fPk: "主键",
		fOp: "操作",
		loadChangeFailed: "加载变更详情失败",
	},
	metaVer: {
		intro: "此页面是 <a href=\"/api/cmdb-template/doc.html#/cmdb-metadata\" target=\"_blank\">/cmdb-metadata</a> 的只读视图。版本/历史快照按 spec §3 的三阶段开关推出。规范见 extract/coche/specs/metadata-versioning.md。",
		tabLog: "评估日志 (影子+执行)",
		tabTags: "标签",
		tabAdapters: "格式适配器",
		colTarget: "目标",
		colPriorVer: "原版本",
		colNote: "备注",
		colCode: "编码",
		colTag: "标签",
		colDescription: "描述",
		colCreated: "创建时间",
		colExtensions: "扩展名",
		colName: "名称",
		colEnabled: "启用",
		on: "启用",
		off: "禁用",
	},
	lifecyclePage: {
		intro: "此页面是 <a href=\"/api/cmdb-template/doc.html#/cmdb-lifecycle\" target=\"_blank\">/cmdb-lifecycle</a> 的只读视图。策略和法律保留的创建走 API;执行严格通过审批工作流(§10.1.3)。规范见 extract/coche/specs/lifecycle-retention.md。",
		tabPolicies: "保留策略",
		tabHolds: "法律保留",
		tabLog: "评估日志 (影子+执行)",
		colTargetType: "目标类型",
		colRetentionDays: "保留天数",
		colAgeAnchor: "年龄锚点",
		colAction: "处置动作",
		colEnabled: "启用",
		colDescription: "描述",
		on: "启用",
		off: "禁用",
		colScope: "范围",
		colTargetId: "目标 ID",
		colReason: "原因",
		colImposed: "施加时间",
		colReleased: "解除时间",
		active: "活跃中",
		colAgeDays: "年龄(d)",
		colRequest: "审批请求",
		colNote: "备注",
	},
	dataSync: {
		title: "数据同步",
		reload: "刷新",
		range7d: "近7天",
		range30d: "近30天",
		range90d: "近90天",
		todayNewPatients: "今日新增患者",
		todayUnits: "今日新增随访单元",
		last7d: "近7天",
		backlog: "待处理单元",
		backlogHint: "已枚举未写入的单元数",
		latestRun: "最近一次运行",
		noRuns: "尚无运行记录",
		noData: "暂无数据",
		chartTitle: "每日更新趋势",
		seriesUnits: "随访单元",
		seriesPatients: "新增患者",
		seriesErrors: "错误数",
		runHistory: "运行历史",
		colBatch: "批次",
		colPhase: "阶段",
		colStatus: "状态",
		colStarted: "开始时间",
		colEnded: "结束时间",
		colDone: "完成",
		colSkip: "跳过",
		colEmpty: "空单元",
		colErrors: "错误",
		colNewPatients: "新增患者",
		colDocuments: "写入文档",
		colNote: "备注",
		detailTitle: "运行详情",
		cacheHits: "缓存命中",
		unrouted: "未路由检查项",
		unmappedEnums: "未匹配枚举值",
		unmappedEnumValues: "被丢弃的枚举取值",
		enumSynonym: "按同义词匹配的取值",
		enumCatchAll: "归入其他类的取值",
		unknownModels: "未知模型",
		multiRecordDropped: "无法存放的多条记录",
		activeFilterSkipped: "跳过的有效行过滤",
		numericPercent: "数值字段：已去除百分号",
		numericDecimal: "数值字段：整数字段收到小数",
		numericThreshold: "数值字段：阈值表述未采纳",
		numericUnit: "数值字段：带单位未采纳",
		numericList: "数值字段：多值未采纳",
		numericQualitative: "数值字段：定性描述未采纳",
		numericThresholdValue: "数值字段：阈值表述明细",
		numericUnitValue: "数值字段：带单位明细",
		numericListValue: "数值字段：多值明细",
		numericQualitativeValue: "数值字段：定性描述明细",
		groupTruncated: "另有 {n} 项未显示",
		scalars: "其他计数",
		colItem: "项目",
		colCount: "次数",
		status: {
			running: "运行中",
			completed: "已完成",
			aborted: "已中止",
			failed: "失败",
		},
	},
	ehealth: {
		openViewer: "打开 eHR Viewer",
		viewerTitle: "eHR 查看器",
		viewerIntro: "在停靠于屏幕右半边的独立窗口中打开香港医健通 <b>eHR Viewer</b>（Mode B 2.1，由 eSC Client 签发票据），随后由医健通要求输入双重认证码。再打开其他患者会替换该窗口；退出本系统会关闭该窗口。医健通不允许其页面被嵌入到其他网站，因此无法在本页面内直接显示。",
		viewerOpenNonPatient: "打开 eHR Viewer（不指定患者）",
		viewerHintWindow: "只有一个停靠窗口：在屏幕右半边打开，新的打开操作会替换上一位参与者，在本系统退出登录会关闭它。",
		viewerHintPatient: "要打开指定患者，请在患者页/随访页顶部的患者信息栏点击“打开 eHR Viewer”。",
		viewerNotMapped: "当前账号未映射医健通 eHR UID，只有已注册的医健通用户才能启动查看器。",
		viewerEscMissing: "服务器未配置 eSC Client 地址，无法启动查看器。",
		viewerNoUrl: "医健通未返回启动地址。",
		viewerPopupBlocked: "浏览器拦截了 eHR Viewer 窗口，请允许本站弹出窗口后重试。",
		uploadReport: "上传收件箱报告（PDF）",
		uploadReportHint: "由 eHR 收件箱打印的处理摘要／异常／重新评级报告。纯图像 PDF 会先 OCR（约 30 秒）。",
		reportDone: "{kind}・{state}・匹配批次 {batches}、记录 {records}",
		reportKind: "类别",
		reportTitle: "标题",
		issuedAt: "发出时间",
		parseState: "读取",
		matchedBatches: "批次",
		matchedRecords: "记录",
		lines: "明细",
		reconcile: "重新核对",
		noReports: "尚未上传任何报告。",
		errorCode: "错误代码",
		errorField: "字段",
		rawLine: "读取原文",
		tabNotifications: "通知",
		poll: "向 eHealth 拉取（GPNH）",
		pollHint: "对外调用：获取自上次窗口以来的同意／主键变更／死亡等通知并应用。全天可用。",
		pollDone: "拉取完成：收到 {received}，应用 {applied}，重复 {duplicates}，未知患者 {unmatched}",
		pendingRepliesTitle: "{n} 条同意通知尚待回复主键核对结果（7 日内）",
		colEvent: "事件",
		changes: "应用的变更",
		reply: "回复",
		replyDue: "期限",
		previewMatch: "预览核对",
		sendReply: "发送回复",
		noReplyDue: "无需回复",
		noNotifications: "尚未应用任何通知。",
		scan: "扫描记录",
		scanHint: "登记本项目的 LABGEN 记录（新增、修改、撤回）。仅本地操作。",
		scanDone: "扫描完成：扫描 {scanned}，登记 {registered}，修改 {amended}，撤回 {withdrawn}",
		transactions: "事务",
		txnDatetime: "事务日期时间",
		outcome: "结果",
		rows: "输出行",
		build: "构建批次",
		buildHint: "将待上传记录组装为已签名、加密的 LABGEN 批次并存于磁盘。点击“上传”前不会发出。",
		buildDone: "已构建 {name}（{mode}）：纳入 {included} 条，排除 {excluded} 条",
		modeAuto: "模式：自动",
		noBatches: "尚未构建批次。",
		colBatchName: "批次（HL7 名称）",
		colParticipants: "患者数",
		colNotes: "构建备注",
		actions: "操作",
		files: "文件",
		upload: "上传（SFTP）",
		checkCollected: "已收取？",
		uploadDone: "已上传——记录转为“已存放”，等待报告",
		remoteDir: "远端目录",
		zipSha: "Zip SHA-256",
		fileKind: "类别",
		fileName: "文件",
		bytes: "字节",
		checksum: "SHA-256",
		open: "打开",
		record: "记录",
		refresh: "刷新",
		colName: "姓名",
		colDob: "出生日期",
		colSex: "性别",
		colConsent: "同意状态",
		colFlags: "标记",
		colQuery: "最近 PMI 查询",
		colEligibleFrom: "可上传起始日",
		unknown: "未知",
		flagDeceased: "已故",
		flagSuspended: "已暂停",
		flagProblem: "问题记录",
		neverQueried: "从未查询",
		pmiSync: "由患者基本信息同步",
		pmiSyncHint: "由“患者基本信息”表单重新推导 PMI 身份行。仅本地操作。",
		pmiSyncDone: "同步完成：扫描 {scanned}，新增 {created}，更新 {updated}，不变 {unchanged}",
		pmiEmpty: "尚无 PMI 身份行——请先在“患者基本信息”表单新增患者，再同步。",
		majorKeys: "主索引键",
		lastDeposit: "最近上传",
		documents: "身份证明文件",
		docType: "类别",
		docNumber: "号码",
		docNumberNorm: "规范化",
		docValidity: "有效性",
		docCurrent: "现行",
		docSuperseded: "已被取代",
		eligibility: "上传资格",
		eligibleYes: "可上传",
		eligibleNo: "不可上传",
		eligibilityNote: "实时依据当前状态及有效期内的最近 PMI 查询计算，从不存为标志。",
		recordDecision: "记录判定",
		pmiQuery: "向 eHealth 查询（PMI Query）",
		pmiQueryHint: "经香港出口对外调用；eHealth 仅在工作日 08:00–18:00（香港时间）响应。",
		pmiQueryDone: "PMI 查询完成",
		keyHistory: "已被取代的主索引键",
		supersededAt: "取代时间",
		surname: "姓氏",
		givenName: "名字",
		reason: {
			OK_JOINING_CONSENT: "eHealth 已确认加入同意",
			NO_EHR_NUMBER: "eHealth 无此主索引键的参与者",
			DECEASED: "患者已登记死亡",
			CONSENT_REVOKED: "对本机构的同意已撤回",
			EMERGENCY_ONLY: "仅紧急访问（只可查看，不可上传）",
			QUERY_STALE: "最近 PMI 查询已过有效期——请重新查询",
			QUERY_UNAVAILABLE: "尚无可用的 PMI 查询结果——请向 eHealth 查询",
		},
		intro: "上传临床数据至香港电子健康记录互通系统（eHRSS）。存放是批次通道，而非逐条保存的 API：记录先在此保存，按数据范畴打包、签名，再经 SFTP 存放，之后由异步报告判定。批次被取走并不等于已被接纳。",
		tabRecords: "记录",
		tabBatches: "批次",
		tabPatients: "PMI 患者",
		tabRegister: "病历登记册",
		registerAllDomains: "全部数据域",
		registerHint: "按患者列出本系统持有的每一份记录，以及把它送交医健通的批次。",
		registerEmpty: "本项目尚未持有临床记录。",
		registerFootnote: "记录先在本系统建立，之后才上传，并注明承载该记录的批次，以证明临床数据由系统直接上传至医健通，而非人工录入。",
		cntPatients: "患者",
		cntRecords: "临床记录",
		cntUploaded: "已上传至医健通",
		cntDomains: "数据域",
		colSummary: "记录",
		colRecordDate: "记录日期",
		colCreatedInEmr: "于本系统建立",
		colUploaded: "上传时间",
		tabReports: "报告",
		tabMapping: "字段映射",
		colRecordKey: "记录键值",
		colDomain: "数据范畴",
		colPatient: "患者",
		colEhrNumber: "eHR 编号",
		colTxn: "事务类别",
		colState: "状态",
		colCreated: "系统内创建时间",
		colDeposited: "存放时间",
		colBatch: "批次",
		colLevel: "评定级别",
		colMode: "模式",
		colTransport: "传输",
		colGenerated: "生成时间",
		colRecordCount: "记录数",
		stateHeld: "保存中",
		stateDeposited: "已存放",
		stateAccepted: "已接纳",
		stateRejected: "已拒绝",
		stateRegraded: "已降级",
		stateWithdrawn: "已撤回",
		depositPending: "等待报告——存放不等于接纳",
		notConfigured: "该项目未配置 eHealth 存放对象（ehealth_hcp_id 为空），只能在此查看记录，无法存放。",
		disabledGlobally: "本部署未启用 eHealth 功能（imles.ehealth.enabled=false）。",
		shadowMode: "影子模式——批次仅生成并记录，不会实际发送。",
		empty: "该项目暂无 eHealth 记录。",
	},
	ingestion: {
		intro: "只读视图。摄取硬化按 spec §3 的三阶段开关推出(Phase A=休眠 / Phase B=影子 / Phase C=enforce)。SFTP 服务器独立 gated 在 <code>imles.ingestion.sftp.enabled</code>。规范见 extract/coche/specs/ingestion-hardening.md。",
		tabChecksum: "校验码 (SHA-256)",
		tabRejections: "拒绝队列",
		tabDedup: "去重表",
		tabSftp: "SFTP 会话",
		hashPlaceholder: "按 SHA-256 查找 (64 hex)",
		colOssFile: "OSS 文件",
		colBytes: "字节",
		colSource: "来源",
		colUploaded: "上传时间",
		colFilename: "文件名",
		colReason: "原因",
		colMode: "影子",
		colDetail: "详细",
		colOriginFileId: "原始文件 ID",
		colReuseCount: "复用次数",
		colFirstSeen: "首次",
		colLastReuse: "最近复用",
		colUser: "用户",
		colAuth: "认证",
		colOpened: "开始",
		colClosed: "结束",
		colUploads: "上传数",
		colTotalBytes: "总字节",
		colCloseReason: "关闭原因",
	},
	dbConfig: {
		title: "数据库配置",
		step1: "选择数据库模型",
		step2: "选择输出形式",
		step3: "配置表单/文档",
		step4: "配置字段",
		selectedOutput: "选定输出形式",
		structuredForm: "结构化表单",
		structuredF1: "· 按照自定义的表单导出数据",
		advFilter: "· 支持高级检索",
		univariate: "· 支持单变量统计分析",
		crfExport: "· 根据数据生成CRF表格，可导出PDF/Word文档",
		defaultForm: "默认表单",
		defaultF1: "· 按照默认结构显示表单",
		formConfigTitle: "项目表单配置",
		formName: "项目表单名称",
		formCode: "项目表单编码",
		formOrder: "项目表单排序",
		visible: "是否显示",
		formModelConfigTitle: "项目表单模型配置",
		selectModel: "选择模型",
		newModel: "新增模型",
		colIndex: "序号",
		modelCode: "模型编码",
		modelName: "模型名称",
		modelDomain: "模型领域",
		modelOrder: "模型排序",
		modelConfigTitle: "项目模型配置",
		modelNameLabel: "项目模型名称",
		modelCodeLabel: "*项目模型编码",
		modelCodeLabelReq: "项目模型编码",
		dontModify: "非必要情况请勿修改",
		deletionMode: "删除方式",
		logical: "逻辑",
		physical: "物理",
		modelDescription: "模型描述",
		showNoteInput: "显示注释输入框",
		note: "注释",
		sceneType: "场景类型",
		sceneDefault: "默认场景",
		sceneTable: "表格场景",
		sceneTableDialog: "表格弹窗场景",
		sceneList: "列表场景",
		uploadAttachment: "上传附件",
		on: "开",
		off: "关",
		saveModelAttrs: "保存模型属性",
		editFields: "编辑字段",
		modelFieldConfigTitle: "项目模型字段配置",
		previous: "上一步",
		next: "下一步",
		selectedInfo: "当前选定信息",
		availableInfo: "可选信息内容",
		codeFormatHint: "请输入字母、数字或下划线",
		selectRowFirst: "请选择一条数据后添加",
		enterModelName: "请输入项目模型名称",
		enterModelCode: "请输入项目模型编码",
		modelCodeFormat: "模型编码只能包含字母、数字和下划线",
		saveFormFirst: "请先保存表单信息",
		modelCodeExists: "该模型编码已存在",
	},
	fieldList: {
		colFieldOrder: "字段排序",
		colIntegrityScore: "完整度分",
		colFieldCode: "字段编码",
		colFieldName: "字段名称",
		colFieldType: "字段类型",
		colVisible: "是否显示",
		colEditable: "是否可编辑",
		colRequired: "是否必填",
		colDictValue: "字典值",
		addField: "添加字段",
		refField: "引用字段",
		dlgEdit: "编辑",
		dlgAdd: "添加",
		order: "排序",
		noSorting: "不排序",
		reservedHint: "以下字段编码具有特殊含义，会自动映射到患者信息表：",
		colMeaning: "含义",
		colDescription: "说明",
		reservedUniqueNote: "其中 <b>card_id</b>、<b>inpatient_id</b>、<b>outpatient_id</b> 具有唯一性约束，同一项目内不允许重复值，可用于防止重复录入患者。",
		fieldNameZh: "字段中文名",
		fieldNameEn: "字段英文名",
		fieldAlias: "字段别名",
		tailLabel: "尾部标签",
		refRange: "参考范围",
		refMin: "下限",
		refMax: "上限",
		refRangeHint: "仅数值类型；越界时标记异常，不阻止保存",
		refRangeInvalid: "参考范围下限不能大于上限",
		fieldDesc: "字段解释",
		controlsVisibility: "是否控制显示",
		controlledFields: "受控字段",
		optionCode: "选项编码",
		optionName: "选项名称",
		controlledFieldCount: "受控字段数量",
		controlledModelCount: "受控模型数量",
		inFormEvent: "表单内事件",
		inModelEvent: "模型内事件",
		inModelClickEvent: "模型内click事件",
		showNoteInput: "显示注释输入框",
		note: "注释",
		subFieldList: "子字段列表",
		refList: "引用列表",
		selectExisting: "选择已有字段",
		colIndex: "序号",
		colModifiedBy: "修改人",
		colModifiedAt: "修改时间",
		dlgSubEdit: "子字段编辑",
		dlgSubAdd: "子字段添加",
		existingFieldList: "已有字段列表",
		fieldControlled: "字段受控",
		modelControlled: "模型受控",
		colFieldId: "字段ID",
		colModelId: "模型ID",
		colModelCode: "模型编码",
		colModelName: "模型名称",
		refSaved: "引用关系保存成功",
		convertedToSub: "已修改为子字段",
		none: "无",
		reserved: {
			name: { n: "姓名", d: "患者姓名" },
			gender: { n: "性别", d: "0=女, 1=男" },
			age: { n: "年龄", d: "患者年龄" },
			birthday: { n: "出生日期", d: "患者生日" },
			phone: { n: "手机号", d: "联系电话" },
			idNum: { n: "身份证号", d: "身份证号码" },
			cardId: { n: "住院卡号", d: "唯一约束，不可重复" },
			inpatientId: { n: "门诊号", d: "唯一约束，不可重复" },
			outpatientId: { n: "住院号", d: "唯一约束，不可重复" },
			admissionTime: { n: "入院时间", d: "日期类型" },
			enrollmentTime: { n: "入组时间", d: "日期类型" },
			diagnosis: { n: "诊断", d: "诊断信息" },
			doctorId: { n: "医生ID", d: "关联医生" },
			doctorName: { n: "医生名字", d: "关联医生姓名" },
			hospitalName: { n: "所属医院", d: "医院名称" },
			status: { n: "患者状态", d: "如：入组、出组" },
			statusCode: { n: "状态编码", d: "状态对应编码" },
		},
	},
	customColumn: {
		title: "设置自定义列",
		searchFieldPh: "输入检索字段的名称",
		name: "名称",
		order: "排序",
		visible: "是否显示",
		description: "描述",
		propertyPath: "属性路径",
		selectProperty: "请选择属性",
		colIndex: "序号",
	},
	piiRule: {
		title: "PII 规则配置",
		currentProject: "当前项目",
		refresh: "刷新",
		readonly: "只读出口脱敏 (read-side anonymisation)",
		readonlyDesc: "规则仅在数据导出与队列检索路径上生效；落盘数据不变。默认 KEEP 表示原样返回。具备 pii.unmask 权限的角色可绕过脱敏 (绕过会被记入审计)。",
		addRule: "新增规则",
		preview: "规则预览",
		saveAll: "保存全部修改",
		empty: "尚未配置任何 PII 规则",
		colField: "字段编码 (field_code)",
		colMode: "脱敏方式",
		colExample: "样例",
		colNote: "备注",
		colOperation: "操作",
		actDelete: "删除",
		modeKeep: "保留原值 (默认)",
		modeMask: "掩码",
		modeRedact: "占位符替换",
		modePseudonym: "项目内确定性化名",
		modeHash: "SHA-256 哈希 (12 hex)",
		modeSuppress: "完全删除字段",
		modeGeneralise: "分桶/分级泛化",
		previewMissingInput: "请填写字段与脱敏方式。",
		draftMissingFieldCode: "新增的规则必须填写字段编码。",
		saveSummary: "已保存 {saved} 条 · 删除 {deleted} 条",
	},
	analytics: {
		overviewTitle: "分析概览",
		datasetTitle: "数据集",
		encodingTitle: "字段编码",
		selectionTitle: "字段筛选",
		algorithmTitle: "算法执行",
		reportTitle: "统计报告",
		researchOverviewTitle: "分析概览",
		libraryTitle: "研究资料",
		topicsTitle: "课题推荐",
		workbenchTitle: "分析工作台",
		refresh: "刷新数据",
		empty: "暂无分析数据",
		statSamples: "样本数",
		statFields: "字段数",
		statAnalyses: "分析数",
		recentAnalyses: "最近分析",
		colName: "分析名称",
		colType: "类型",
		colCreatedAt: "创建时间",
		colOperation: "操作",
		actView: "查看",
		viewDetail: "查看详情",
		typeAlgorithm: "算法执行",
		typeReport: "统计报告",
		errorProject: "项目信息未找到",
		errorFetch: "获取数据失败",
		topics: {
			rescoreBtn: "按最新数据重新评估",
			runDiscovery: "运行发现",
			rediscoverForce: "重新发现（忽略已处理）",
			searchPlaceholder: "搜索选题...",
			sourceDocPlaceholder: "来源文档",
			variantTypePlaceholder: "类型",
			variant: {
				guidanceExtraction: "指南提取",
				subgroup: "亚组分析",
				combination: "联合治疗",
				methodology: "方法学",
				validation: "验证研究",
				novelAssociation: "新关联",
				endpoint: "终点分析",
				uncategorised: "未分类",
			},
			status: {
				proposed: "待审核",
				approved: "已批准",
				rejected: "已拒绝",
				deferred: "已暂缓",
				exploredNull: "已探索·未见显著",
			},
			foundTopics: "已发现 {n} 个新选题",
			initialising: "正在初始化...",
			recommendTitle: "数据就绪推荐",
			recommendSub: "已按本项目实际数据填充率评估，以下课题现有数据可支撑分析",
			dataReadyPct: "数据就绪 {n}%",
			retrospectiveFeasible: "回顾性可做",
			needProspective: "需前瞻数据",
			startResearch: "开始研究分析",
			emptyTopics: "暂无推荐课题",
			runTopicDiscovery: "运行课题发现",
			compositeScore: "综合评分",
			scoreComposite: "综合",
			feasibilityScore: "可行性评分",
			scoreFeasible: "可行",
			dataCompleteness: "数据完整度",
			scoreData: "数据",
			relevanceHigh: "高度相关",
			relevanceNormal: "相关",
			noRelatedLiterature: "未检索到高度相关文献",
			novelty: {
				wellCovered: "文献高度重合",
				partiallyCovered: "已有类似研究",
				novel: "新颖性良好",
			},
			label: {
				studyDesign: "研究设计:",
				primaryEndpoint: "主要终点:",
				dataFeasibility: "数据可行性:",
				requiredFields: "所需字段:",
				prospectiveNeeds: "需补充采集:",
				analysisPath: "分析路径:",
				suggestedAngle: "建议差异化角度:",
				sourceDocs: "来源文档:",
			},
			dataReadyFields: "数据就绪 {matched}/{total} 字段",
			fieldMissingMark: "·缺",
			docCount: "{n} 篇文档",
			downloadPdf: "下载PDF",
			docNotFound: "文档未找到",
			viewSourceLink: "查看来源",
			docType: {
				guidance: "指南文献",
				research: "研究文献",
				clinicalTrial: "临床试验",
				reference: "参考文件",
			},
			approve: "批准",
			defer: "暂缓",
			reject: "拒绝",
			editAndApprove: "编辑后批准",
			editDialogTitle: "编辑课题",
			form: {
				titleCn: "课题标题",
				titleEn: "英文标题",
				studyDesign: "研究设计",
				primaryEndpoint: "主要终点",
				hypothesis: "研究假设",
				notes: "备注",
				notesPlaceholder: "附加研究备注",
			},
			saveAndApprove: "保存并批准",
			fieldMatched: "已匹配数据库字段: {field}",
			fieldUnavailable: "数据库暂无此字段，需补充采集",
			fieldSample: "样本: {n}",
			msg: {
				downloadFailed: "下载失败",
				noProfile: "尚未生成数据画像，请先在「研究资料 → 数据集」生成数据画像",
				rescoreDone: "已按最新数据重新评估 {n} 个课题，其中 {ready} 个数据就绪",
				rescoreFailed: "重新评估失败",
				approveFailed: "课题批准失败，请稍后重试",
				projectNotFound: "项目信息未找到",
				discoveryStarted: "课题发现已启动",
				discoveryStartFailed: "启动发现失败",
				discoveryDone: "发现完成: {n} 个新选题",
				discoveryFailed: "发现失败: {error}",
				unknownError: "未知错误",
				confirmReject: "确定拒绝此课题？",
				approved: "课题已批准，可点击「开始研究分析」进入研究流程",
				rejected: "课题已拒绝",
				deferred: "课题已暂缓",
				editedApproved: "课题已编辑并批准，可点击「开始研究分析」进入研究流程",
				sessionCreated: "已创建研究会话，正在进入分析工作台",
				sessionCreateFailed: "创建研究会话失败",
			},
			design: {
				retrospectiveCohort: "回顾性队列研究",
				prospectiveCohort: "前瞻性队列研究",
				caseControl: "病例对照研究",
				crossSectional: "横断面研究",
				rct: "随机对照试验",
				metaAnalysis: "荟萃分析",
				survivalAnalysis: "生存分析",
				prognosticFactor: "预后因素分析",
				diagnosticAccuracy: "诊断准确性研究",
				registryStudy: "登记研究",
				caseSeries: "病例系列",
			},
			term: {
				crisisOccurrence: "肌无力危象发生率",
				crisisIncidence: "肌无力危象发生率",
				myasthenicCrisis: "肌无力危象",
				mgAdlTotal: "MG-ADL总分",
				qmgScore: "QMG评分",
				mgQol15rScore: "MG-QOL15r评分",
				mgfaClassification: "MGFA临床分型",
				ossermanClassification: "Osserman分型",
				mse: "微小状态(MSE)",
				mms: "微小表现状态(MMS)",
				csr: "完全稳定缓解(CSR)",
				atFollowUp: "（随访时）",
				at12MonthFollowUp: "（12个月随访时）",
				baseline: "基线",
				duringFollowUp: "随访期间",
				duringDiseaseCourse: "病程中",
				achievementOf: "达到",
				associationBetween: "关联：",
				neckMuscleStrength: "颈部肌力",
				thyroidFunction: "甲状腺功能",
				autoantibody: "自身抗体",
				serumCreatinine: "血清肌酐",
				urea: "尿素",
				smoking: "吸烟",
				and: "与",
			},
		},
		library: {
			tabDataset: "数据集",
			tabGuidance: "指南文献",
			tabResearch: "研究文献",
			tabReference: "参考文件",
			modeNew: "新数据集",
			modeVersion: "新版本",
			uploadDataset: "上传数据集",
			generating: "生成中...",
			refreshProfile: "刷新数据画像",
			generateProfile: "生成数据画像",
			clinicalDbPatients: "临床数据库 {n} 名患者",
			profileFieldCount: "画像 {n} 字段",
			profileTitle: "数据画像",
			profileTag: "每字段填充率 / 去重 / 分布",
			profileHint: "分析按需从原始树状数据展开生成，本画像用于研判课题数据可行性",
			multiRecordTag: "多记录 · 分析时按需展开",
			colField: "字段",
			colType: "类型",
			colFillRate: "填充率",
			colUniqueCount: "去重数",
			colDistribution: "分布 / 样例",
			emptyDatasets: "暂无数据集，点击上方按钮上传",
			colDatasetName: "数据集名称",
			colDatasetCode: "编码",
			colSource: "来源",
			colLatestVersion: "最新版本",
			colHeaderRows: "标题行",
			colDescription: "描述",
			colUploadTime: "上传时间",
			actVersions: "版本",
			actDownload: "下载",
			actRename: "重命名",
			previewTitle: "数据预览",
			previewBaseline: "基本信息 / 基线",
			previewBaselineCount: "{n} 名患者",
			previewFollowup: "随访记录",
			previewFollowupCount: "{n} 条",
			emptyPreview: "暂无预览数据",
			uploadNewDataset: "上传新数据集",
			uploadNewVersion: "上传新版本",
			fieldSelectDataset: "选择数据集",
			placeholderSelectDataset: "选择要更新的数据集",
			placeholderDatasetName: "如: 胃癌患者数据集",
			fieldDatasetCode: "数据集编码",
			placeholderDatasetCode: "可选，留空自动生成",
			fieldHeaderRowCount: "标题行数量",
			fieldVersion: "版本号",
			placeholderVersionDesc: "版本描述（可选）",
			fieldDataFile: "数据文件",
			dragOrClick: "拖拽文件或",
			clickToUpload: "点击上传",
			tipDatasetFormats: "支持 .xlsx, .xls, .csv",
			uploading: "上传中...",
			upload: "上传",
			versionsTitle: "数据集版本",
			colVersion: "版本",
			colStatus: "状态",
			tagCurrent: "当前",
			colRowCount: "行数",
			colColumnCount: "列数",
			colCreateTime: "创建时间",
			actActivate: "激活",
			renameTitle: "重命名数据集",
			placeholderDescriptionOptional: "描述（可选）",
			profileDone: "数据画像已生成",
			profileDoneDetail: "共 {n} 个字段的填充率与分布已统计完成",
			generateFailed: "生成失败",
			uploadReference: "上传参考文件",
			referenceHint: "上传研究中需要参考的各类文件",
			emptyReference: "暂无参考文件",
			colFileName: "文件名",
			colFileSize: "文件大小",
			placeholderFileDesc: "文件描述（可选）",
			fieldFile: "文件",
			maxFiles5: "（最多5个）",
			uploadGuidance: "上传指南文献",
			extracting: "提取中...",
			extractTopics: "提取研究选题",
			guidanceHint: "上传医学指南 PDF，再点「提取研究选题」由 AI 生成研究方向",
			emptyGuidance: "暂无指南文献，点击上方按钮上传医学指南 PDF",
			colTitle: "标题",
			colRelevance: "相关度",
			colTopics: "选题",
			topicsExtracted: "已提取 {n}",
			statusFailed: "失败",
			statusPending: "待提取",
			placeholderBatchDesc: "批次描述（可选，应用到本次上传的所有文件）",
			maxFiles20: "（可多选，最多20个）",
			tipGuidanceFormats: "支持 .pdf 文件；同名文件已存在时会跳过",
			resultOk: "成功",
			resultSkipped: "跳过",
			extractDone: "提取完成",
			extractFailed: "提取失败",
			searching: "搜索中...",
			searchPubmed: "从PubMed搜索",
			searchCT: "从ClinicalTrials.gov搜索",
			researchHint: "基于项目ICD10编码搜索治疗效果相关的研究文献和临床试验",
			pubmedSearchDone: "PubMed搜索完成:",
			pubmedSearchFailed: "PubMed搜索失败:",
			ctSearchDone: "ClinicalTrials搜索完成:",
			ctSearchFailed: "ClinicalTrials搜索失败:",
			emptyResearch: "暂无研究文献，点击上方按钮从PubMed或ClinicalTrials.gov搜索",
			colJournalStatus: "期刊/状态",
			colPubDate: "发表日期",
			actLink: "链接",
			fieldCount: "数量",
			start: "开始",
			startSearch: "开始搜索",
			typeNumber: "数值",
			typeString: "文本",
			typeDate: "日期",
			typeSingleSelect: "单选",
			typeMultiSelect: "多选",
			avgSelections: "平均选 {n} 项",
			numericRange: "{min}–{max}（均 {mean}）",
			sourceUpload: "上传",
			sourceResearch: "研究产出",
			sourceDbImportLegacy: "数据库导入(旧)",
			sourceDatabase: "数据库",
			sourceAiFilter: "智能筛选",
			msgNewDatasetUploaded: "新数据集上传成功",
			msgNewVersionUploaded: "新版本上传成功",
			msgUploadFailed: "上传失败",
			msgColumnMismatch: "列定义与之前版本不匹配，请确保数据结构一致",
			msgPreviewFailed: "加载预览数据失败",
			msgVersionsFailed: "获取版本信息失败",
			msgRenameSuccess: "重命名成功",
			msgRenameFailed: "重命名失败",
			confirmDeleteDataset: "确定删除数据集「{name}」？此操作将同时删除所有版本。",
			confirmDeleteTitle: "确认删除",
			msgDatasetDeleted: "数据集已删除",
			msgDeleteFailed: "删除失败",
			msgDownloadFailed: "下载失败",
			msgVersionActivated: "版本已激活",
			msgActivateFailed: "激活失败",
			confirmDeleteVersion: "确定删除版本 {version}？",
			msgVersionDeleted: "版本已删除",
			confirmGenerateProfile: "将扫描临床数据库中 {n} 名患者的全部病历，统计每个字段的数据画像（填充率、去重数、取值分布），用于研判\"哪些课题我们已有数据\"。此操作可能需要几分钟。",
			msgProfileStartFailed: "启动生成失败",
			msgInitializing: "正在初始化...",
			msgProcessing: "处理中...",
			msgRefUploaded: "参考文件上传成功",
			confirmDeleteFile: "确定删除文件「{name}」？",
			uploadProgress: "正在上传 ({current}/{total})",
			msgFilesUploaded: "成功上传 {n} 个文件",
			msgFilesSkipped: "，{n} 个跳过",
			msgNoFileUploaded: "没有文件上传成功",
			confirmDeleteNamed: "确定删除「{name}」？",
			msgExtractAlreadyRunning: "提取任务已在运行中...",
			msgExtractStartFailed: "启动提取失败",
			extractSummary: "处理 {processed} 篇，提取 {topics} 个选题",
			extractSkipped: "，跳过 {n} 篇",
			crawlPubmedTitle: "搜索PubMed研究文献",
			crawlPubmedMessage: "将基于项目ICD10编码，从PubMed搜索治疗效果相关的研究文献。",
			msgPubmedStarted: "PubMed搜索已启动，可继续操作",
			msgSearchAlreadyRunning: "搜索任务已在运行中...",
			msgSearchStartFailed: "启动搜索失败",
			researchSummary: "获取 {downloaded} 篇，跳过 {skipped} 篇",
			researchFailedCount: "，失败 {n} 篇",
			msgSearchFailed: "搜索失败",
			crawlCtTitle: "搜索ClinicalTrials.gov临床试验",
			crawlCtMessage: "将基于项目ICD10编码，从ClinicalTrials.gov搜索相关的临床试验。",
			msgCtStarted: "ClinicalTrials搜索已启动，可继续操作",
			ctSummary: "获取 {downloaded} 个，跳过 {skipped} 个",
			ctFailedCount: "，失败 {n} 个",
			docTitleWithFile: "{desc}（{file}）",
		},
		researchHome: {
			noDisease: "未设置疾病",
			noObjective: "未设置研究目标",
			activeResearch: "进行中的研究",
			viewAll: "查看全部",
			continueAnalysis: "继续分析",
			recommendedTopics: "推荐课题（数据就绪）",
			dataReadyPct: "数据就绪 {n}%",
			treatmentInsights: "治疗洞察",
			exploring: "探索进行中",
			exploreNow: "立即探索",
			autopilotAlertWithTopic: "自动探索进行中：正在分析「{title}」— 约需 1–3 小时，期间可离开此页",
			autopilotAlert: "自动探索进行中 — 约需 1–3 小时，完成的研究与洞察将自动出现，期间可离开此页",
			noInsights: "暂无治疗洞察 — 研究完成后将自动提炼关键发现",
			pickDataReadyTopic: "挑选数据就绪课题",
			openWorkbench: "进入分析工作台",
			researchRecords: "研究记录",
			colTitle: "研究题目",
			colStatus: "状态",
			colCohort: "队列",
			colInsights: "洞察",
			colUpdatedAt: "更新时间",
			noResearch: "暂无研究 — 从数据就绪课题一键开始",
			projectSettings: "项目设置",
			diseaseName: "疾病名称",
			diseasePlaceholder: "如: 胃癌",
			icd10Codes: "ICD-10编码",
			icd10Placeholder: "输入编码后回车添加",
			researchObjective: "研究目标",
			objectivePlaceholder: "描述本项目的整体研究方向和目标",
			autopilot: "自动探索",
			intervalPrefix: "每",
			intervalSuffix: "天自动运行一次",
			autopilotOffHint: "关闭后仍可在课题页手动发起分析",
			autopilotHint: "每次运行自动发现课题并完成一项统计分析（约 1–3 小时推理算力）；到期后于凌晨 3 点启动。",
			statDocuments: "研究文档",
			statTopics: "推荐课题",
			statAnalyses: "分析任务",
			subDataReady: "{n} 个数据就绪",
			subActive: "{n} 个进行中",
			subFindings: "{n} 条发现",
			autopilotDone: "自动探索已完成",
			autopilotConfirmMsg: "将自动发现研究课题并逐个尝试统计分析——不显著就换下一个方向，直到产出有统计学意义的发现或候选课题用尽。可能运行数小时并消耗较多推理算力。是否现在开始？",
			startExplore: "开始探索",
			autopilotAlreadyRunning: "自动探索已在进行中",
			autopilotStarted: "自动探索已启动，完成后新的研究与洞察将自动出现",
			autopilotStartFailed: "启动自动探索失败",
			settingsSaved: "设置已保存",
			settingsSaveFailed: "保存设置失败",
			status: {
				active: "进行中",
				completed: "已完成",
				failed: "失败",
				archived: "已归档",
			},
		},
		workbench: {
			title: "科研分析工作台",
			backToList: "返回列表",
			archivedTitle: "未见显著探索",
			archivedToggle: "未见显著探索 ({n})",
			refresh: "刷新",
			newStudy: "新建研究",
			emptyArchived: "暂无未见显著的自动探索",
			emptySessions: "暂无研究分析会话",
			createFirst: "创建第一个研究",
			colTitle: "研究题目",
			tagAuto: "自动",
			colStage: "当前阶段",
			colStatus: "状态",
			colCohort: "队列",
			colInsights: "洞察",
			colUpdated: "更新时间",
			colActions: "操作",
			open: "打开",
			startOver: "重新开始",
			tabPipeline: "流程",
			viewingConfirmedStage: "正在查看已确认的历史环节（只读）。点击「{stage}」可回到当前环节。",
			interpretDisabledHint: "完成统计分析后可用",
			tabInterpret: "解读与探索",
			createTitle: "新建研究分析",
			labelHypothesis: "研究假设",
			hypothesisPlaceholder: "例如：超适应症与适应症支架治疗 sICAS 的安全性与中长期结局差异",
			labelMode: "运行方式",
			modeAuto: "自动探索（推荐）",
			modeManual: "逐步确认",
			modeAutoHint: "全程自动跑完；若无统计学意义的结果会自动更换策略重试（最多 8 轮）。全程可实时观看，随时暂停、指导或停止。",
			modeManualHint: "每个环节由您确认后再继续（原有流程）。",
			labelCohort: "研究队列",
			cohortFromFilter: "来自 AI 高级筛选",
			cohortPaste: "粘贴患者编号",
			cohortLater: "稍后绑定",
			labelConversation: "筛选会话",
			conversationPlaceholder: "选择已保存的 AI 筛选会话",
			labelPatientIds: "患者编号",
			patientIdsPlaceholder: "以逗号、空格或换行分隔的 patient_no",
			create: "创建",
			cohortBlockedReason: "请先在下方选择研究人群并点击「绑定队列」；如确需全项目分析，请选择「使用全项目患者」后绑定。",
			restartConfirm: "从第 1 步重做本研究？研究卡片、队列、变量映射、统计结果与既有解读都会清空；研究选题、假设与已上传的指南保留，并可重新选择研究人群。",
			deleteConfirm: "确定删除「{name}」？删除后无法恢复。",
			deleteTitle: "确认删除",
			status: {
				active: "进行中",
				completed: "已完成",
				failed: "失败",
				abandoned: "已放弃",
			},
			msg: {
				openFailed: "打开会话失败",
				noProject: "未获取到当前项目",
				selectConversation: "请选择筛选会话",
				pastePatientIds: "请粘贴至少一个患者编号",
				createFailed: "创建会话失败",
				restarted: "已重置，请重新起草研究卡片",
				deleted: "已删除",
				confirmFailed: "确认失败",
				rejectFailed: "退回失败",
			},
		},
		inbox: {
			title: "治疗回顾",
			unreadCount: "{n} 未读",
			markAllRead: "全部标为已读",
			refresh: "刷新",
			emptyDesc: "暂无治疗回顾 — 平台将随数据积累自动生成分析发现并在此推送",
			viewTopics: "查看课题推荐",
			loadFailed: "加载治疗回顾失败",
			markedAllRead: "已全部标为已读",
		},
		insightCard: {
			sourceAnalysisTask: "来源：分析任务",
			autoDiscovered: "自动发现",
			effectSize: "效应量",
			type: {
				treatmentEfficacy: "治疗对比",
				biomarker: "生物标志物",
				survival: "生存分析",
				composite: "综合分析",
				descriptive: "数据概览",
				autoSchema: "智能发现",
			},
		},
		studyInsight: {
			autoDiscovered: "自动发现",
			pendingTooltip: "报告主要结论含临床价值判断，待医生在报告“作者补充事项”中确认",
			pendingTag: "待确认",
			patternTag: "模式",
			patternTooltip: "临床实践模式探查：描述诊疗实践本身（做了什么、谁被选择做了什么、怎么变的），未做疗效比较，不可作因果解读",
			findingCount: "{n} 条发现",
			status: {
				active: "进行中",
				completed: "已完成",
				failed: "失败",
				abandoned: "已放弃",
			},
		},
		pipe: {
			interpret: {
				title: "解读与探索",
				regenerateReport: "重新生成报告",
				generateReport: "生成报告",
				bundle: "完整分析包",
				evidenceHint: "报告引用文献均来自平台检索并核验的证据包（共 {n} 篇）。",
				roundLabel: "第 {n} 轮探索",
				tagNeedsReflatten: "需重新展平",
				tagProposed: "待确认",
				tagDone: "已重跑",
				reflattenTitle: "该调整需重新展平数据（新建研究会话）",
				proposedChanges: "拟调整项",
				confirmRerun: "确认并重跑",
				keyEffects: "关键效应量",
				conclusion: "结论解读",
				caveatsLabel: "统计学注意事项",
				limitationsLabel: "研究局限",
				noInterpretation: "尚未生成解读。",
				generateInterpretation: "生成解读",
				stop: "停止",
				elapsed: "已用时",
				stepLabel: "第 {n} 步",
				methodSuggestions: "方法建议",
				inputPlaceholder: "提出调整方向：更换协变量、加亚组、改匹配卡钳、去掉某个终点…（Ctrl+Enter 发送）",
				inputHint: "统计有效性由智能体保证，临床相关性由您把关。",
				send: "发送",
				working: "处理中…",
				model: {
					logistic: "Logistic 回归",
					cox: "Cox 生存分析",
					linear: "线性回归",
					geeLogistic: "GEE（随访级）",
					clusterLogistic: "聚类稳健 Logistic",
					coxTv: "时变 Cox",
					aipw: "AIPW 双稳健（风险差）",
				},
				diff: {
					groupColumn: "分组变量",
					positiveGroup: "暴露组",
					referenceGroup: "参照组",
					covariates: "校正变量",
					tableOne: "基线表变量",
					matching: "倾向评分匹配",
					iptw: "IPTW 加权",
					models: "统计模型",
					roc: "ROC 分析",
					longitudinal: "各时点比较",
					competingRisks: "竞争风险分析",
					subgroups: "亚组分析",
					subgroupEndpoint: "亚组终点",
					analysisUnit: "分析单位",
					clusterColumn: "聚类变量",
					seed: "随机种子",
				},
				diffVal: {
					removed: "（取消）",
					matchingOff: "不做匹配",
					caliper: "卡钳 {v}",
					psOn: "按 {cols}",
					iptwStabilized: "稳定化权重",
					iptwUnstabilized: "非稳定化权重",
					none: "取消",
				},
				msg: {
					figuresLoadFailed: "图表加载失败——登录可能已过期，请刷新页面重新登录后再打开本研究。",
				},
				chipAddText: "请加做「{name}」（{hook}），依据：{reason}。",
				chipMethodText: "请补充「{name}」（{hook}）。",
			},
			loop: {
				autoExplore: "自动探索",
				iterationCount: "第 {n}/{total} 轮",
				pause: "暂停",
				resume: "继续",
				stopKeepBest: "停止并采用当前最优",
				continueExploring: "继续探索",
				baselineEvaluation: "基线评估",
				running: "进行中…",
				startingFirst: "正在启动第一轮探索…",
				methodLadder: "方法阶梯",
				guidePlaceholder: "给下一轮策略的指导意见（可选）：如「试试以随访日期为时间零点」「分组改按有无手术记录」…（Ctrl+Enter 发送）",
				guideHint: "探索不会因此中断；这段话会在 AI 制定下一轮策略时被采纳。",
				queuedCount: "已排队 {n} 条",
				sendGuide: "发送指导",
				ladderInUse: "已在用：{items}",
				ladderNext: "建议下一步：{items}",
				ladderSparseEvents: "事件不足——先换终点/人群，不换方法",
				axesChanged: "改动：{names}",
				msg: {
					guideQueued: "已排队，将在下一轮策略中采纳",
					guideFailed: "发送失败",
				},
				stopConfirmText: "停止自动探索？将保留当前最优结果并生成报告（探索过程保留在此时间线，不进入报告）；之后仍可点「继续探索」追加轮次。",
				stopConfirmTitle: "停止探索",
				stop: "停止",
			},
			results: {
				sectionEndpointRates: "终点事件率",
				sectionEffectEstimates: "效应量估计（校正 / IPTW / 匹配）",
				sectionSurvival: "生存分析（log-rank）",
				sectionRoc: "诊断/判别价值（ROC）",
				sectionTimepoints: "各时点比较",
				sectionTableOneSingle: "表一 —— 全队列描述",
				sectionTableOneBalance: "表一 —— 基线均衡性",
				sectionMatching: "倾向评分匹配 / IPTW",
				sectionCompetingRisks: "竞争风险分析（Aalen–Johansen 累计发生率 + 病因别 Cox）",
				sectionEvalue: "未测混杂敏感性（E 值）",
				sectionSubgroups: "亚组分析",
				sectionFigures: "统计图",
				col: {
					endpoint: "终点",
					evaluable: "可评估",
					events: "事件",
					byGroupRate: "分组事件率",
					model: "模型",
					estimate: "估计值",
					estimateShort: "估计",
					variants: "各法估计",
					assumptions: "模型诊断",
					byGroupSurvival: "分组（n / 事件 / 中位天数）",
					cutoff: "界值",
					sens: "灵敏度",
					spec: "特异度",
					acc: "准确率",
					timepoint: "时点",
					test: "检验",
					pAdj: "P(校正)",
					variable: "变量",
					overall: "描述",
					analysis: "分析",
					causeSpecificHr: "病因别 HR (95%CI)",
					competingCauseHr: "竞争事件 HR",
					cif: "累计发生率（时点）",
					effect: "效应",
					rrApprox: "近似 RR（换算）",
					evalue: "E值",
					evalueCi: "E值（CI 界）",
					level: "亚组",
				},
				delongCi: "DeLong 95%CI",
				holmAdjusted: "（Holm 校正）",
				interactionP: "交互作用 P",
				evalueHint: "要完全解释掉当前效应，未测混杂需同时与暴露、结局达到的最小关联强度（RR 尺度）——E 值越大结论越稳健。",
				matching: {
					method: "方法",
					matchedPairs: "匹配对数",
					seed: "随机种子",
					treatedControl: "暴露 / 对照",
					maxSmdBefore: "匹配前最大SMD",
					maxSmdAfter: "匹配后/加权后最大SMD",
					weighting: "加权方式",
					weightAto: "重叠加权（ATO，均衡人群）",
					weightIptw: "稳定化 IPTW",
					ess: "加权有效样本量",
					essRatio: "（{pct}%）",
					commonSupport: "PS 共同支撑",
				},
				status: {
					insufficientEvents: "事件数不足",
					insufficientData: "数据不足",
					nonNumericEndpoint: "终点非数值",
					noOutcomeVariance: "结局无差异",
					columnsAbsent: "缺少列",
					endpointAbsent: "无此终点",
					unstable: "拟合不稳定",
					missingTimeEventColumns: "缺时间/事件列",
					insufficient: "样本不足",
					failed: "失败",
					fitFailed: "拟合失败",
				},
				refGroup: "对照组",
				posGroup: "暴露组",
				diag: {
					epvText: "每变量事件数：{events} 事件 / {parameters} 个参数（阈值 {threshold}）",
					ph: "比例风险",
					phHolds: "比例风险假定成立（Schoenfeld 残差 P≥0.05）",
					phViolated: "以下协变量违反比例风险假定：{vars}",
					normality: "残差正态",
					equalVar: "方差齐性",
					separation: "疑似分离",
					separationText: "置信区间跨度异常，提示准完全分离，具体数值不可解释",
				},
				listSep: "、",
				sepSemi: "；",
				variantStandardizedRd: "标准化风险差",
				variantBayesian: "贝叶斯后验",
				pDirection: "P(方向)",
				numericDesc: "{mean} ± {sd}；中位数 {median} ({q1}–{q3})，n={n}",
				rrApproxText: "{rr}（{conversion}）",
			},
			stage: {
				round: "第 {n} 轮",
				roundShort: "第{n}轮",
				confirmPlan: "确认方案",
				submitRevision: "提交修改意见",
				redraft: "重新起草",
				regenerate: "重新生成",
				latestFeedback: "上轮修改意见（第{n}轮）",
				earlierFeedback: "更早的修改意见（{n}条）",
				working: "正在运行…",
				elapsed: "已用时",
				step: "第 {n} 步",
				longHint: "起草时间较长属正常：AI 会先通读本项目的字段字典再落笔。您可以离开本页，该步骤会继续在后台运行。",
				executionLog: "执行日志（{n} 条）",
				revisionFeedback: "修改意见",
				revisePlaceholder: "用一句话说明想怎么改：如「终点改为30天再治疗」「协变量加入糖尿病史」…（Ctrl+Enter 提交）",
				reviseHint: "AI 将按您的意见重写草案，重写后仍需您确认才会生效。",
				nothingProposed: "尚无提案",
				pickLine: "关于「{question}」：采用「{label}」",
				regenConfirmMsg: "放弃本轮草案并重新起草？",
				status: {
					proposed: "待确认",
					confirmed: "已确认",
					rejected: "已退回",
					error: "出错",
					pending: "待运行",
				},
			},
			decision: {
				title: "关键决策点",
				recommended: "推荐",
				applyHint: "此选择将随「提交修改意见」由 AI 重写草案后生效。",
			},
			effect: {
				colEndpoint: "终点",
				colModel: "模型",
				colEffect: "效应量 (95%CI)",
				tooFewEvents: "—（事件过少）",
				colEvents: "事件",
			},
			verify: {
				titleFail: "叙述审校未通过 —— 以下问题解决前，本研究不会推送到治疗回顾",
				titleWarn: "叙述审校：存在提示项",
				sevContradiction: "矛盾",
				sevNote: "提示",
				reviewTitle: "多视角审稿",
				statRounds: "轮次",
				statIssues: "意见",
				statFixed: "已修订",
				statToAuthor: "待作者",
				statDropped: "已驳回",
				tagBlocker: "阻断",
				tagAuthor: "待作者",
				claimTitle: "主张核验",
				primaryUnresolved: "主要结论待医生确认",
				primary: "主要结论",
				hint: "所有数字均由平台计算，只有 AI 撰写的叙述可能与之不符。重新生成解读或报告即可重新审校。",
				claimSupported: "有支持",
				claimPartiallySupported: "部分支持",
				claimUnsupported: "无支持",
				claimContradicted: "相矛盾",
				claimNeedsConfirmation: "待医生确认",
				quoted: "「{text}」",
			},
			stepper: {
				study_intake: "研究卡片",
				cohort_confirm: "队列确认",
				variable_mapping: "变量映射",
				flatten_preview: "数据展平",
				encoding_exclusion: "编码与排除",
				analysis: "统计分析",
				report_export: "报告与导出",
			},
			body: {
				study: {
					disease: "疾病",
					hypothesis: "研究假设",
					design: "研究设计",
					groupingVariable: "分组变量",
					onLabel: "适应症",
					offLabel: "超适应症",
					endpoints: "研究终点",
					covariates: "协变量",
				},
				cohort: {
					source: "来源",
					matched: "命中例数",
					filterConversation: "筛选会话",
					querySummary: "筛选说明",
					samplePatients: "样例患者：",
					unboundWarning: "尚未绑定队列 —— 将分析全项目全部患者。",
					unboundPickWarning: "尚未绑定队列 —— 直接确认将分析全项目全部患者。请在下方选择研究人群。",
					changeCohort: "更换队列",
					modeConversation: "来自 AI 高级筛选",
					modeManual: "粘贴患者编号",
					modeAll: "使用全项目患者",
					selectConversationPlaceholder: "选择已保存的 AI 筛选会话",
					matchedCountSuffix: "（{n} 例）",
					noConversations: "暂无已保存的 AI 筛选会话 —— 可到 数据管理 → 高级筛选 → AI筛选 构建队列后返回。",
					pastePlaceholder: "以逗号、空格或换行分隔的 patient_no",
					allNote: "明确选择分析本项目全部患者（不作人群限定）。",
					bindCohort: "绑定队列",
					msg: {
						selectConversation: "请选择筛选会话",
						pasteAtLeastOne: "请输入至少一个患者编号",
						wholeProjectSelected: "已选择全项目患者",
						cohortBound: "已绑定队列：{n} 例",
						bindFailed: "绑定队列失败",
					},
				},
				variables: {
					endpointCount: "{n} 个终点",
					groupCount: "{n} 个分组",
					visitLevel: "随访级分析",
					studyGroups: "研究分组",
					presenceRule: "有「{field}」记录即为{pos}，没有则为{neg}",
					cutAt: "按 {cuts} 分组",
					quantileRule: "按队列分位数 {cuts} 切分（切点在展平时按实际队列求出）",
					endpoints: "研究终点",
					survival: "生存分析",
					positiveValue: "取值为「{v}」时计为发生",
					dataIncluded: "纳入的数据",
					allDataKept: "保留全部模型与字段；同一患者的多次记录按字段类型自动汇总（数值取均值、日期取最早、其余合并）。",
					noSpecTitle: "尚未定义分组变量与研究终点",
					noSpecDesc: "现在确认将只能做描述性统计。如需组间比较，请在下方「修改意见」里说明分组与终点口径，或点「重新起草」。",
					allModels: "全部模型",
					modelCount: "{n} 个模型",
					dayRange: "第 {lo}–{hi} 天",
					atDay: "第 {d} 天",
					atDayTol: "第 {d} 天（{tol} 天内取最近）",
					sustained: "持续 ≥{d} 天",
					binarize: "{rule} 记为事件",
				},
				flatten: {
					patientRows: "患者表行数",
					visitRows: "随访表行数",
					analysisRows: "分析表行数",
					codebookCols: "编码表列数",
					deriveSummary: "派生变量概览",
					colKey: "项目",
					colValue: "值",
					previewTitle: "数据预览（前若干行）",
					tabPatient: "患者表",
					tabVisit: "随访表",
					tabAnalysis: "分析表",
				},
				encoding: {
					exclusionRules: "排除规则",
					keep: "保留：",
					variableEncoding: "变量编码",
					colVariable: "变量",
					colPositive: "阳性值",
					missingPolicy: "缺失处理策略",
				},
				analysis: {
					analysisN: "分析样本",
					groups: "分组",
					grouping: "分组变量",
					covariates: "协变量",
					matching: "匹配",
					models: "模型",
					methodCheck: "方法核对",
					applicable: "可用",
					suggested: "项升级建议",
					inUse: "已在用",
					alsoApplicable: "亦可用",
					notFeasible: "不可行",
					roadmap: "进阶方向",
					roadmapHint: "{trigger}（平台暂不支持）",
					results: "统计结果",
				},
				report: {
					title: "题目",
					design: "设计",
					cohort: "队列例数",
					analysisN: "分析样本",
					groups: "分组",
					keyFindings: "主要结果",
					colEndpoint: "终点",
					colModel: "模型",
					colEffect: "效应量 (95%CI)",
					downloads: "下载",
					rebuildTables: "重建数据表",
					pendingAuthor: "待作者确认 {n} 项（见报告“作者补充事项”）",
					completedNote: "流程已完成。可复现分析包重跑得到逐字节一致的 results.json。",
					rebuildOk: "数据表已重建：分析表 {n} 行",
					rebuildFailed: "重建失败，请稍后重试",
					downloadFailed: "该文件尚未生成或下载失败",
					dl: {
						bundle: "完整分析包",
						strobeDocx: "研究报告 (Word)",
						script: "可复现脚本",
						scriptR: "R 脚本",
						results: "结果 JSON",
						analysisCsv: "分析表",
						patientCsv: "患者表",
						visitCsv: "随访表",
						codebook: "编码表",
					},
				},
			},
			hooks: {
				loopReconnecting: "连接中断，正在重新接入自动探索…",
				processFailed: "处理失败",
				explorationDisconnected: "与服务器的连接已中断，该任务已停止。请刷新页面后重试。",
				advanceDisconnected: "与服务器的连接已中断，本步骤可能已停止。请刷新页面：若仍在运行会自动重新接入，否则可重新执行该步骤。",
				durationMinSec: "{m} 分 {s} 秒",
				durationSec: "{s} 秒",
			},
		},
		dataset: {
			modeNew: "新数据集",
			modeVersion: "新版本",
			selectDataset: "选择数据集",
			selectDatasetPlaceholder: "选择要更新的数据集",
			datasetName: "数据集名称",
			datasetCodeOptional: "数据集编码（可选）",
			autoGenerateHint: "如留空将自动生成",
			version: "版本",
			versionHint: "建议版本号，您可以根据需要进行修改",
			headerRowCount: "标题行数量",
			headerRowCountHint: "指定数据文件中的标题行数量 (1-10)",
			datasetDescription: "数据集描述",
			datasetFile: "数据集文档",
			selectFile: "选择文件",
			acceptHint: "支持扩展名：.xlsx, .xls, .csv",
			uploading: "正在上传...",
			uploadNewDataset: "上传新数据集",
			uploadNewVersion: "上传新版本",
			manageTitle: "数据集管理",
			datasetCode: "数据集编码",
			latestVersion: "最新版本",
			versionDescription: "版本描述",
			uploadTime: "上传时间",
			versionHistory: "历史版本",
			viewVersions: "查看版本",
			versionsDialogTitle: "数据集版本",
			createdAt: "创建时间",
			description: "描述",
			msgSelectFile: "请选择文件",
			msgSelectDatasetToUpdate: "请选择要更新的数据集",
			msgDatasetNotFound: "无法找到选定数据集的详细信息。请刷新列表或重试。",
			msgUploadNewSuccess: "新数据集上传成功",
			msgUploadVersionSuccess: "数据集 {name} 的新版本 {version} 上传成功",
			msgUploadError: "上传数据集时出错",
			msgColumnMismatch: "无法上传新版本：列定义与之前的版本不匹配。请确保数据结构一致。",
			msgFileInvalid: "无法处理文件：文件格式无效或损坏。请确保文件是有效的 CSV 或 Excel 文件。",
			msgLoadDatasetsFailed: "加载数据集失败",
			msgLoadVersionsFailed: "加载数据集版本失败",
		},
		nav: {
			title: "数据分析工具",
			overview: "分析概览",
			dataset: "数据集",
			encoding: "字段编码",
			selection: "字段筛选",
			algorithm: "算法执行",
			report: "统计报告",
		},
		encoding: {
			saveConfig: "保存配置",
			exportProcessedData: "导出处理数据",
			selectDatasetLabel: "选择要处理的数据集",
			selectDatasetPlaceholder: "选择数据集",
			noDatasetsForProject: "未找到该项目的数据集，请先上传数据集。",
			tabMetadata: "1. 字段分类",
			datasetLabel: "数据集",
			rescanMetadata: "重新扫描元数据",
			dataTypeDetails: "数据类型详情",
			numericStats: "数值型: 最小值: {min}, 最大值: {max}, 平均值: {mean}, 中位数: {median}, 标准差: {std}",
			categoricalStats: "分类型: 类别: {categories} (有序: {ordered})",
			nullFrequency: "空值频率",
			uniqueCount: "唯一值数量",
			dataQuality: "数据质量",
			colColumnName: "列名",
			colDataType: "数据类型",
			colNullable: "可为空",
			colUnique: "是否唯一",
			goToImputation: "进入缺失值填补",
			tabImputation: "2. 缺失值填补",
			noColumnsForImputation: "没有可用于填补的列。",
			imputationTip: "可以为任意列设置填补策略，即使该列没有缺失值。这对于处理未来可能出现的缺失值很有帮助。",
			fieldStatistics: "字段统计信息",
			colMissingBefore: "填补前缺失率",
			colImputationStrategy: "填补策略",
			selectStrategy: "选择策略",
			colParameters: "参数",
			paramTypeTodo: "参数类型 '{type}' 待配置",
			noParameters: "无参数",
			colMissingAfter: "填补后缺失率",
			helpLabel: "帮助",
			imputationHelp: "数值型数据可用均值/中位数填补；分类数据可用众数填补。时间序列数据可用前值填充法（LOCF）。请考虑临床应用的实际意义。",
			backToMetadata: "返回元数据",
			resetToDefault: "重置为默认",
			applyImputationContinue: "应用填补并继续",
			tabEncoding: "3. 编码策略",
			outputColumnStatistics: "编码输出列统计信息",
			dataLoading: "数据加载中...",
			colEncodingStrategy: "编码策略",
			colOutputPreview: "输出列预览",
			infoLossWarning: "选定的编码策略可能会导致信息丢失（例如，丢弃类别）。",
			backToImputation: "返回填补",
			applyEncodingSave: "应用编码并保存",
			dataPreviewTitle: "数据预览（样本）",
			refreshPreview: "刷新预览",
			auditLogTitle: "转换审计日志",
			noAuditRecords: "暂无转换记录。",
			dataPreview: "数据预览",
			auditLog: "审计日志",
			paramEnter: "输入 {name}",
			paramBasedOnType: " (基于列类型: {type})",
			paramDefault: ", 默认: {value}",
			paramTupleExample: "例如 (0, 1), 默认: {value}",
			paramCommaList: "逗号分隔列表, 默认: {value}",
			msgNoDatasets: "未找到数据集",
			msgFetchDatasetsFailed: "获取数据集列表失败",
			msgLoadDatasetMetadataFailed: "加载数据集元数据失败",
			auditLoadMetadata: "加载元数据",
			auditLoadMetadataDetail: "已加载 {n} 个列的元数据",
			msgNoColumnMetadata: "未找到列元数据",
			msgFetchColumnMetadataFailed: "获取列元数据失败",
			msgRescanComplete: "元数据重新扫描完成",
			msgRescanFailed: "重新扫描元数据失败",
			msgResetImputationSuccess: "已重置为默认填补策略",
			msgResetImputationFailed: "重置为默认填补策略失败",
			msgFetchImputationFailed: "获取填补策略失败",
			msgFetchEncodingFailed: "获取编码策略失败",
			columnCount: "({n} 列)",
			msgEncodingSaved: "编码策略保存成功",
			auditApplyEncoding: "应用编码策略",
			auditApplyEncodingDetail: "应用了 {n} 个列的编码策略",
			msgConfigSavedContent: "数据编码配置已成功保存。您可以下载处理后的数据或者继续进行其他操作。",
			msgConfigSavedTitle: "配置保存成功",
			msgApplyEncodingFailed: "应用编码策略失败",
			msgNoEncodingSelected: "未选择任何编码策略",
			msgProjectOrDatasetMissing: "项目或数据集未选择",
			msgImputationApplied: "填补策略应用成功",
			auditApplyImputation: "应用填补策略",
			auditApplyImputationDetail: "应用了 {n} 个列的填补策略",
			msgApplyImputationFailed: "应用填补策略失败",
			msgNoImputationSelected: "未选择任何填补策略，直接进入编码步骤。",
			msgApplyImputationError: "应用填补策略时发生错误",
			sampleData: "示例数据 {n}",
			colSampleData: "数据样本",
			msgFetchPreviewFailed: "获取数据预览失败",
			msgSaveConfigConfirm: "是否保存当前数据处理配置？",
			msgConfigSaved: "配置已保存",
			msgExportConfirm: "是否导出处理后的数据？",
			exportDataTitle: "导出数据",
			msgExportStarted: "数据导出已开始",
			msgCancelConfirm: "是否取消当前操作并返回？未保存的更改将丢失。",
			msgCancelTitle: "确认取消",
		},
		selection: {
			datasetSelection: "数据集选择",
			chooseDataset: "选择数据集",
			datasetPlaceholder: "请选择要进行变量选择的数据集",
			datasetCode: "数据集代码",
			datasetName: "数据集名称",
			prepProgress: "数据准备进度",
			roleAssignment: "列角色分配",
			autoDetectTarget: "自动检测目标变量",
			selectAllFeatures: "全选为特征",
			clearSelection: "清空选择",
			selectAllAsX: "全选为X变量",
			autoDetectY: "自动检测Y变量",
			colName: "列名",
			colDataType: "数据类型",
			colStats: "统计信息",
			uniqueValues: "唯一值",
			missingRate: "缺失率",
			varType: "变量类型",
			selectType: "选择类型",
			roleY: "Y变量 (目标)",
			roleGrouping: "分组变量",
			roleX: "X变量 (特征)",
			roleId: "ID变量",
			roleExcluded: "排除",
			roleUnassigned: "未分配",
			powerAnalysis: "统计功效分析",
			runPowerAnalysis: "执行功效分析",
			alphaLevel: "显著性水平 (α)",
			power: "统计功效",
			effectSize: "效应量",
			effectSmall: "小",
			effectMedium: "中",
			effectLarge: "大",
			detectedAnalysis: "检测到{type}分析",
			regression: "回归",
			classification: "分类",
			powerAdequate: "统计功效充足",
			powerInadequate: "统计功效不足",
			currentSampleSize: "当前样本量",
			recommendedSampleSize: "建议样本量",
			actualPower: "实际功效",
			smartFeatureSelection: "智能特征选择",
			runFeatureSelection: "执行特征选择",
			featureSelectionAlertTitle: "基于统计功效分析的智能特征选择",
			featureSelectionAlertDesc: "使用Lasso回归识别最重要的特征，同时确保样本量充足以维持统计功效",
			recommendedFeatureCount: "推荐特征数量",
			maxFeaturesAllowed: "最大允许特征数",
			lassoAlpha: "Lasso参数α",
			importanceThreshold: "重要性阈值",
			recommendedFeatureList: "推荐特征列表",
			applyRecommendedFeatures: "应用推荐特征",
			featureImportanceTitle: "特征重要性评分",
			sortDesc: "降序",
			sortOriginal: "原始顺序",
			featureName: "特征名称",
			importanceScore: "重要性评分",
			optimizationSuggestions: "优化建议",
			saveConfig: "保存配置",
			nextAlgorithm: "下一步：算法选择",
			columnDetailTitle: "列详情：{name}",
			displayName: "显示名",
			uniqueValueCount: "唯一值数",
			currentRole: "当前角色",
			confirmApply: "应用",
			msgSelectProject: "请先选择项目",
			msgNoDatasets: "未找到可用的数据集",
			msgFetchDatasetsFailed: "获取数据集列表失败",
			msgCannotBeY: "该列不能作为Y变量（包含NaN值或数据类型不合适）",
			msgCannotBeGrouping: "该列不能作为分组变量（必须是分类变量）",
			msgNoColumnsForAutoDetect: "没有可用的列来自动检测Y变量。",
			msgAutoDetectedYMoved: "自动检测到Y变量: {name} (原Y变量 {old} 已移至X变量)。",
			msgAutoDetectedY: "自动检测到Y变量: {name}。",
			msgAutoDetectYFailed: "未能自动检测到合适的Y变量。请手动选择。",
			msgLoadSelectionFailed: "加载数据集 {dataset} 的列选择配置失败",
			msgSaveSelectionSuccess: "列选择配置已保存",
			msgSaveSelectionFailed: "保存列选择配置失败",
			msgCompleteSelectionFirst: "请先完成列选择配置",
			msgPowerAnalysisDone: "功效分析完成",
			msgPowerAnalysisFailed: "功效分析失败",
			msgCompletePowerAnalysisFirst: "请先完成功效分析",
			msgFeatureSelectionDone: "智能特征选择完成，推荐 {n} 个特征",
			msgFeatureSelectionFailed: "智能特征选择失败",
			msgApplyFeaturesConfirm: "是否应用推荐的 {n} 个特征作为X变量？这将替换当前的X变量选择。",
			msgFeaturesApplied: "已应用推荐的特征选择",
			stepDatasetSelected: "数据集已选择",
			stepTargetSet: "目标变量已指定",
			stepFeaturesSelected: "特征变量已选择",
			stepPowerAnalysisDone: "功效分析已完成",
			stepFeatureSelectionDone: "智能特征选择已完成",
			msgCompleteVarConfig: "请完成必要的变量配置",
			msgConfigSavedRedirect: "配置已保存，正在跳转到算法选择页面",
			msgPrepareAnalysisFailed: "准备分析失败: {msg}",
			msgInitFailed: "初始化失败",
			msgProjectCleared: "项目信息已清除，请重新选择项目。",
		},
		algorithm: {
			datasetSelection: "数据集选择",
			selectDataset: "选择数据集",
			datasetPlaceholder: "请选择要执行算法的数据集",
			datasetCode: "数据集代码",
			datasetName: "数据集名称",
			configAndRun: "算法配置与执行",
			dataConfigOverview: "数据配置概览",
			backToDataPrep: "返回数据准备",
			targetVariable: "目标变量",
			analysisType: "分析类型",
			classification: "分类",
			regression: "回归",
			featureCount: "特征变量数量",
			totalColumns: "总列数",
			selectedFeatures: "已选择的特征变量",
			moreFeatures: "+{n} 更多...",
			globalConfig: "全局配置",
			executing: "执行中... ({done}/{total})",
			runComparison: "运行算法比较 ({selected}/{total})",
			optimizationMetric: "优化指标",
			metricAccuracy: "准确率",
			metricPrecision: "精确率",
			metricRecall: "召回率",
			metricF1: "F1分数",
			metricMae: "平均绝对误差",
			metricMse: "均方误差",
			metricRmse: "均方根误差",
			metricR2: "R²值",
			cvFolds: "交叉验证折数",
			autoTune: "自动调参",
			algorithmSelectionTitle: "算法选择与参数配置",
			emptyAlgorithms: "暂无可用算法",
			recommended: "推荐",
			collapseParams: "收起参数",
			expandParams: "展开参数",
			paramConfig: "参数配置",
			noParamsNeeded: "此算法无需参数配置",
			comparisonTitle: "算法比较结果",
			exportComparison: "导出比较结果",
			clearResults: "清除结果",
			bestAlgorithmTitle: "最优算法: {name}",
			bestAlgorithmDesc: "基于{metric}指标，{name}表现最佳，得分: {score}",
			metricsComparison: "性能指标对比",
			colAlgorithm: "算法",
			tagBest: "最优",
			colExecTime: "执行时间(秒)",
			comparisonCharts: "算法对比图表",
			chartsGeneratingTitle: "对比图表生成中",
			chartsGeneratingDesc: "算法对比图表正在生成中，请稍后刷新查看",
			chartPerformanceComparison: "算法性能总体对比",
			chartPerformanceComparisonAlt: "算法性能总体对比图",
			chartMetricsHeatmap: "指标热力图",
			chartCvBoxplot: "交叉验证分数分布",
			chartCvBoxplotAlt: "交叉验证分数分布图",
			chartRocComparison: "ROC曲线对比",
			chartRocComparisonAlt: "ROC曲线对比图",
			chartPrComparison: "PR曲线对比",
			chartPrComparisonAlt: "PR曲线对比图",
			detailedAnalysis: "{name} 详细分析",
			chartFeatureImportance: "特征重要性",
			chartFeatureImportanceAlt: "{name} 特征重要性图",
			featureImportanceUnavailable: "特征重要性图表不可用",
			chartConfusionMatrix: "混淆矩阵",
			chartConfusionMatrixAlt: "{name} 混淆矩阵",
			confusionMatrixUnavailable: "混淆矩阵图表不可用",
			chartMetrics: "性能指标",
			chartMetricsAlt: "{name} 性能指标图",
			chartRocCurve: "ROC曲线",
			chartRocCurveAlt: "{name} ROC曲线",
			executionLog: "执行日志",
			noDatasetTitle: "请选择数据集",
			noDatasetDesc: "请先选择一个已完成数据准备配置的数据集来执行算法分析",
			msgLoadConfigFailed: "加载数据配置失败",
			msgLoadAnalysisFailed: "加载已有分析失败",
			msgLoadAlgorithmsFailed: "获取可用算法失败",
			msgSelectAtLeastOne: "请至少选择一个算法",
			msgExecuteSuccess: "成功执行 {n} 个算法",
			msgComparisonFailed: "算法执行失败: {msg}",
			msgCompleteConfig: "请完成数据配置并选择算法",
			msgScheduleCreated: "算法定期执行计划已创建",
			msgExecuteFailed: "执行算法失败",
			msgChartImageFailed: "图表图片加载失败",
			msgComparisonExported: "比较结果已导出",
			msgNoProjectInfo: "无法获取项目信息以加载数据集，请确保已选择一个项目。",
			msgNoDatasets: "未找到可用的数据集或数据格式不正确",
			msgLoadDatasetsFailed: "获取数据集列表失败: {msg}",
			msgInitFailed: "初始化失败",
		},
		report: {
			contextTitle: "研究背景信息",
			analysisDone: "已完成算法分析",
			analysisPending: "等待算法分析",
			projectCode: "项目代码:",
			dataset: "数据集:",
			sampleSize: "样本量:",
			casesUnit: "例",
			bestAlgorithm: "最佳算法:",
			targetVariable: "目标变量:",
			modelPerformance: "模型性能:",
			configTitle: "报告配置",
			loadConfig: "加载配置",
			refreshList: "刷新列表",
			saveConfig: "保存配置",
			generateStrobe: "生成STROBE报告",
			selectDatasetFirst: "请先选择数据集",
			selectDatasetHint: "请选择一个已完成数据处理和算法分析的数据集来生成报告",
			datasetPlaceholder: "选择数据集",
			sectionBasic: "基本信息",
			studyTitle: "研究标题",
			studyTitlePlaceholder: "例如：XXX治疗方案对患者预后的影响研究",
			researchObjective: "研究目标",
			researchObjectivePlaceholder: "请详细描述您的研究目标，包括：\n1. 研究问题或假设\n2. 预期要验证的关系\n3. 临床意义或应用价值\n\n示例：本研究旨在评估不同化疗方案对晚期胃癌患者总生存期的影响，并分析患者基线特征对治疗效果的预测价值，以为临床治疗决策提供循证依据。",
			studyDesign: "研究设计类型",
			studyDesignPlaceholder: "选择研究设计类型",
			design: {
				retrospectiveCohort: "回顾性队列研究",
				prospectiveCohort: "前瞻性队列研究",
				caseControl: "病例对照研究",
				crossSectional: "横断面研究",
				cohort: "队列研究",
			},
			sectionReferences: "参考文档",
			documentManagement: "文档管理",
			dropFilesHere: "将文件拖拽到此处或",
			clickToUpload: "点击上传",
			uploadTip: "支持文档(.pdf, .doc, .docx, .txt, .md)、数据文件(.xlsx, .xls, .csv)、图片(.jpg, .png, .gif, .svg)、压缩包(.zip, .rar)等格式",
			descriptionPlaceholder: "添加文档描述（可选）",
			uploadFiles: "上传文件",
			uploadedFiles: "已上传的参考文档 ({n})",
			refresh: "刷新",
			col: {
				filename: "文件名",
				size: "大小",
				uploadTime: "上传时间",
				description: "描述",
				reportName: "报告名称",
				templateType: "模板类型",
				status: "状态",
				createdAt: "创建时间",
			},
			noDescription: "无描述",
			download: "下载",
			noReferenceFiles: "暂无参考文档，可以上传相关的临床指南、研究文献等文档",
			studyBackground: "研究背景",
			studyBackgroundPlaceholder: "简要描述研究背景和临床问题（可选）",
			studyPeriod: "研究时间范围",
			rangeSeparator: "至",
			startTime: "开始时间",
			endTime: "结束时间",
			monthFormat: "YYYY年MM月",
			sectionReportSettings: "报告设置",
			reportTemplate: "报告模板",
			tplCompleteTitle: "完整STROBE报告",
			tplCompleteDesc: "包含STROBE检查表的所有22个条目",
			tplEssentialTitle: "核心STROBE报告",
			tplEssentialDesc: "关键条目的简化版本",
			tplClinicalTitle: "临床总结报告",
			tplClinicalDesc: "面向临床应用的简明报告",
			outputFormat: "输出格式",
			fmtHtml: "HTML网页版",
			fmtPdf: "PDF文档",
			fmtWord: "Word文档",
			language: "语言",
			langZh: "中文",
			langEn: "英文",
			langBoth: "中英双语",
			advancedOptions: "高级选项",
			collapse: "收起",
			expand: "展开",
			includeSections: "包含章节",
			sec: {
				titleAbstract: "标题和摘要",
				introduction: "引言",
				methods: "方法",
				results: "结果",
				discussion: "讨论",
				conclusion: "结论",
				limitations: "局限性",
				funding: "资助信息",
			},
			specialRequirements: "特殊要求",
			specialRequirementsPlaceholder: "其他特殊要求或说明（可选）",
			historyTitle: "历史报告",
			previewTitle: "报告预览",
			generatingReport: "正在生成报告，请稍候...",
			noReportContent: "暂无报告内容",
			downloadReport: "下载报告",
			rule: {
				studyTitleRequired: "请输入研究标题",
				studyTitleMin: "标题至少5个字符",
				researchObjectiveRequired: "请输入研究目标",
				researchObjectiveOptional: "研究目标可选填写",
			},
			msg: {
				fetchProjectFailed: "获取项目信息失败",
				selectProjectFirst: "请先选择项目",
				fetchDatasetsFailed: "获取数据集列表失败",
				defaultStudyTitle: "{name}数据分析报告",
				loadDatasetFailed: "加载数据集信息失败",
				completeRequired: "请完善必填信息",
				reportGenerating: "报告正在生成中，请稍候...",
				reportGenerated: "报告生成成功！",
				generateFailed: "生成报告失败: {msg}",
				configSaved: "报告配置已保存",
				saveConfigFailed: "保存配置失败: {msg}",
				configsRefreshing: "配置列表正在刷新，请稍候",
				configLoaded: "已加载配置: {name}",
				loadConfigFailed: "加载配置失败: {msg}",
				configsRefreshed: "配置列表已刷新",
				refreshConfigsFailed: "刷新配置列表失败",
				reportDetailUnavailable: "报告详情不可用",
				loadReportFailed: "加载报告失败",
				noReportId: "无法获取报告ID",
				downloadStarted: "报告下载已开始",
				downloadReportFailed: "下载报告失败",
				reportsRefreshed: "报告列表已刷新",
				loadReferenceFilesFailed: "加载参考文档失败",
				fileTooLarge: "文件大小不能超过50MB",
				selectFilesToUpload: "请选择要上传的文件",
				projectInfoIncomplete: "项目信息不完整",
				uploadSuccess: "文件上传成功",
				uploadFailed: "文件上传失败: {msg}",
				unknownError: "未知错误",
				fileDownloaded: "文件下载完成",
				fileDownloadFailed: "文件下载失败",
				confirmDeleteFile: "确定要删除文件 \"{name}\" 吗？此操作不可撤销。",
				confirmDeleteTitle: "确认删除",
				fileDeleted: "文件删除成功",
				fileDeleteFailed: "文件删除失败",
				iframeLoadFailed: "报告内容加载失败，请检查文件URL是否正确",
				fetchProjectFailedPartial: "获取项目信息失败，部分功能可能受限",
				initFailed: "初始化失败: {msg}",
				defaultConfigName: "配置_{time}",
			},
			status: {
				generating: "生成中",
				completed: "已完成",
				failed: "失败",
				pending: "等待中",
			},
		},
	},
	clinic: {
		operationOverview: "运营概览",
		appointments: "加号申请",
		checkins: "报到列表",
		chatHistory: "聊天历史",
		users: "门诊用户管理",
		refresh: "刷新",
		today: "今日",
		last7d: "近7天",
		last30d: "近30天",
		last90d: "近90天",
		custom: "自定义",
		dateSep: "至",
		startDate: "开始日期",
		endDate: "结束日期",
		kpiTotalUsers: "累计用户",
		kpiNewUsers: "期内新增用户",
		kpiActiveUsers: "活跃用户",
		kpiDeactivated: "已停用账号",
		kpiSnapshot: "当前快照",
		kpiMessages: "期内消息总数",
		kpiConversations: "期内对话总数",
		kpiUploads: "期内上传病历数",
		kpiFollowupMessages: "期内随访消息",
		recentRegistrations: "近期注册",
		// 门诊用户管理 list
		searchPlaceholder: "搜索昵称 / 手机号 / openid",
		searchBtn: "搜索",
		showDeleted: "显示已注销账号",
		totalCount: "共 {n} 条",
		emptyUsers: "暂无用户",
		colUser: "用户",
		colContact: "联系方式",
		colLoginType: "登录方式",
		colLastLogin: "最近登录",
		colStatus: "状态",
		colRemark: "备注",
		colActions: "操作",
		statusDeleted: "已注销",
		statusActive: "已开通",
		statusDisabled: "已停用",
		loginWechat: "微信",
		loginPassword: "账号",
		loginBoth: "双绑",
		internalFlag: "可体验新功能",
		disable: "停用",
		restore: "恢复",
		disableTitle: "停用账号",
		restoreTitle: "恢复账号",
		disableConfirm: "即将{action}用户 {name}。",
		disableNote: "停用后该用户登录将提示「您的账号暂无访问权限」，无法继续使用，但已有的数据保留。",
		reasonLabel: "原因（可选，会展示给用户）",
		confirm: "确定",
		cancel: "取消",
		save: "保存",
		opSuccess: "操作成功",
		opFailed: "操作失败",
		loadFailed: "加载失败",
		internalOn: "已设为可体验新功能",
		internalOff: "已取消体验权限",
		viewDetail: "详情",
		// 用户详情 page
		userDetail: "用户详情",
		backToList: "返回列表",
		profile: "用户资料",
		loginCount: "登录次数",
		createdAt: "注册时间",
		lastLoginIp: "登录IP",
		patientTimelines: "患者时间线",
		noPatients: "暂无患者档案",
		correctionHint: "时间线由系统自动生成，医生可修正；用户提交的原始聊天与资料不可编辑。",
		tabConversations: "会话记录",
		tabAppointments: "加号申请",
		tabCheckins: "报到记录",
		tabAssessments: "评估结果",
		convTitle: "会话标题",
		convTheme: "话题",
		convPending: "待回复",
		convMessages: "消息数",
		convLastActive: "最近活动",
		patient: "患者",
		// 患者时间线 component
		patientInfo: "患者信息",
		patientName: "姓名",
		patientGender: "性别",
		patientDob: "出生日期",
		hospitalCards: "就诊卡",
		baseline: "基线",
		followUps: "随访记录",
		viewSource: "查看来源",
		assessmentSource: "来源：问卷评估",
		timelineMissing: "未找到患者时间线数据",
		correctedBadge: "医生已修正",
		correctedAt: "修正时间",
		editEvent: "编辑",
		deleteEvent: "删除",
		editEventTitle: "修正随访事件",
		eventDate: "日期",
		eventType: "事件类型",
		removeField: "删除字段",
		undoRemove: "撤销删除",
		complexFields: "复杂字段",
		complexFieldsNote: "结构化字段，以 JSON 格式编辑；保存前会校验格式。",
		invalidJson: "{key} 的 JSON 格式有误，请检查后再保存",
		addField: "新增字段",
		fieldKey: "字段名",
		fieldValue: "值",
		add: "添加",
		reservedFieldKey: "该字段为系统保留字段",
		duplicateFieldKey: "字段已存在",
		noChanges: "未检测到修改",
		correctionSaved: "修正已保存",
		correctionFailed: "操作失败，请稍后重试",
		deleteEventTitle: "删除确认",
		deleteEventConfirm: "确认删除该随访事件（{type} {date}）？此操作不可撤销。",
		eventDeleted: "已删除",
	},
	discern: {
		title: "AI识别列表",
		uploader: "上传用户：",
		userType: "用户类型：",
		identifyStatus: "识别状态：",
		confirmStatus: "确认状态：",
		input: "请输入",
		select: "请选择",
		userDoctor: "医生",
		userPatient: "患者",
		userSys: "管理员",
		statusUnfinished: "未完成",
		statusFinished: "已完成",
		statusPending: "待确认",
		statusConfirmed: "已确认",
		searchBtn: "查 询",
		resetBtn: "重 置",
		qrCode: "二维码",
		batchUpload: "批量上传",
		colIndex: "序号",
		colUploader: "上传用户",
		colUserType: "用户类型",
		colProject: "项目名称",
		colFileCount: "图片数量",
		colUploadTime: "上传时间",
		colIdentifyStatus: "识别状态",
		colIdentifyTime: "识别时间",
		colConfirmStatus: "确认状态",
		colConfirmUser: "确认用户",
		colConfirmTime: "确认时间",
		colOperation: "操作",
		actView: "查看",
		actConfirm: "确认",
		viewTitle: "AI识别详情",
		batchUploadTitle: "批量上传",
		dropFiles: "将文件拖到此处，或",
		clickUpload: "点击上传",
		fileTip: "仅支持 JPG/PNG，单文件不超过 10MB",
		startUpload: "开始上传",
	},
	governance: {
		title: "审批收件箱",
		myTitle: "我的申请",
		refresh: "刷新",
		colId: "申请ID",
		colType: "类型",
		colRequester: "申请人",
		colCreatedAt: "申请时间",
		colStatus: "状态",
		colOperation: "操作",
		actView: "查看",
		actApprove: "通过",
		actReject: "驳回",
		statusPending: "待审批",
		statusApproved: "已通过",
		statusRejected: "已驳回",
		statusCancelled: "已取消",
		drawerTitle: "申请详情",
		approve: "通过",
		reject: "驳回",
		comment: "审批意见",
		commentPh: "请输入审批意见",
		noPendingStep: "没有待审批步骤",
		emptyCommentConfirm: "驳回建议填写理由,确定空备注提交吗?",
		confirmTitle: "确认",
		toastApproved: "已通过",
		toastRejected: "已驳回",
		quickConfirmBody: "{action} 申请 #{id}?",
		quickConfirmTitle: "确认操作",
	},

	consent: {
		admin: {
			tabTemplates: "模板管理",
			tabSignatures: "医生签名",
			noProject: "缺少项目参数，请从项目管理页进入。",
			noPermission: "您没有知情同意书模板管理权限，请联系系统管理员。",
			templateHint: "同一类型下只能有一个已发布版本；已发布的模板不可修改，如需调整请新建版本。",
			templateEmpty: "该项目还没有知情同意书模板",
			newTemplate: "新建模板",
			colFamily: "类型",
			colName: "名称",
			colVersion: "版本",
			colStatus: "状态",
			colSource: "来源",
			colPages: "页数",
			colUpdated: "更新时间",
			colActions: "操作",
			status: {
				DRAFT: "草稿",
				ACTIVE: "已发布",
				RETIRED: "已停用",
			},
			actZones: "标注",
			actPreview: "预览",
			actEdit: "编辑",
			actPublish: "发布",
			actRetire: "停用",
			actNewVersion: "新版本",
			actDelete: "删除",
			familyHint: "同一份同意书的类型标识，例如 F2F（面对面）、PHONE（电话）",
			versionHint: "例如 V3.0a",
			sourcePdf: "PDF 上传",
			sourceText: "纯文本",
			file: "模板文件",
			chooseFile: "选择 PDF",
			fileHint: "仅支持未加密的 PDF 文件",
			textBody: "正文",
			textHint: "系统据此生成 PDF，并自动追加一页标准签名页",
			remark: "备注",
			effectiveDate: "生效日期",
			effectiveDatePlaceholder: "选择日期",
			editMeta: "编辑模板信息",
			createIncomplete: "请填写类型、名称与版本",
			needPdf: "请选择 PDF 模板文件",
			needText: "请填写模板正文",
			createDone: "模板已创建（草稿）",
			saveDone: "已保存",
			publishConfirm: "确定发布「{name}」？同类型下已发布的版本将自动停用。",
			publishDone: "模板已发布",
			retireConfirm: "确定停用「{name}」？停用后签署页将不再显示该版本。",
			retireDone: "模板已停用",
			newVersionBody: "基于 {version} 复制为新草稿，请输入新的版本号",
			versionRequired: "请输入版本号",
			newVersionDone: "新版本草稿已创建",
			deleteConfirm: "确定删除「{name}」{version}？此操作不可恢复。",
			deleteDone: "模板已删除",
			zoneTitle: "标注签名区域",
			zoneList: "区域列表",
			zoneEmpty: "还没有标注任何区域",
			zoneNoSelection: "在左侧页面上拖拽以新建区域，或点击已有区域进行编辑",
			zoneReadonly: "只读",
			zoneReadonlyHint: "已发布/已停用的模板不可修改标注，如需调整请新建版本",
			zoneDrawHint: "拖拽空白处新建区域；拖拽方框移动；拖拽角点缩放；Delete 删除选中区域",
			zoneDirty: "有未保存的修改",
			zoneSave: "保存标注",
			zoneSaved: "标注已保存",
			zoneDiscardTitle: "放弃未保存的修改？",
			zoneDiscardBody: "标注尚未保存，关闭后修改将丢失。",
			zoneKey: "标识 (key)",
			zoneKeyHint: "小写字母、数字与下划线，1-32 位；签署时用于匹配签名图片",
			zoneKeyInvalid: "只允许小写字母、数字与下划线，1-32 位",
			zoneKeyInvalidAt: "区域标识「{key}」不合法：只允许小写字母、数字与下划线，1-32 位",
			zoneKeyDuplicate: "区域标识「{key}」重复",
			zoneType: "类型",
			zoneRole: "角色",
			zoneLabel: "显示名称",
			zoneSource: "自动填充",
			zonePage: "页码",
			zoneFormat: "格式",
			zoneFormatHint: "例如 yyyy年MM月dd日；日期类区域必填",
			zoneRect: "位置与大小（页面比例 0-1）",
			zoneRectHint: "x/y 为左上角坐标，w/h 为宽高，均为页面宽高的比例",
			zoneRequired: "必填",
			zoneMask: "覆盖底纹",
			zoneMaskHint: "签署时先涂白该区域，用于覆盖预印文字",
			zoneDelete: "删除该区域",
			prevPage: "上一页",
			nextPage: "下一页",
			type: {
				SIGNATURE: "签名",
				DATE: "日期",
				DATETIME: "日期时间",
				DATETIME_RANGE: "时间区间",
				TEXT: "文本",
				CHECKBOX: "勾选框",
			},
			source: {
				none: "不自动填充",
				patient_no: "研究参与者筛选号",
				patient_name: "研究参与者姓名",
				doctor_name: "研究人员姓名",
				signed_date: "签署日期",
			},
			signatureHint: "为项目成员维护签名图片；签署时「研究人员」区域使用登录人自己的签名。",
			memberEmpty: "该项目还没有成员",
			colNickname: "姓名",
			colUsername: "账号",
			colSignature: "签名",
			noSignature: "未设置",
			actUpload: "上传",
			actDraw: "手写",
			actDeleteSignature: "删除",
			chooseImage: "选择图片",
			uploadHint: "建议使用背景透明的 PNG；若为白底扫描件，请勾选「去除白底」。",
			needImage: "请选择签名图片",
			needDrawing: "请先完成签名",
			signatureSaved: "签名已保存",
			signatureDeleted: "签名已删除",
			deleteSignatureConfirm: "确定删除 {name} 的签名？",
		},
		panel: {
			title: "知情同意书",
			sign: "签署知情同意书",
			empty: "暂无签署记录",
			colTemplate: "模板",
			colVersion: "版本",
			colSignedDate: "签署日期",
			colDoctor: "研究人员",
			colStatus: "状态",
			view: "查看",
			download: "下载",
			voidAction: "作废",
			voidPromptTitle: "作废签署记录",
			voidPromptBody: "作废后该记录不再作为有效知情同意，文件仍会保留。请填写作废原因（{template}）。",
			voidReasonPlaceholder: "请填写作废原因，200 字以内",
			voidReasonRequired: "请填写作废原因",
			voidReasonTooLong: "作废原因不能超过 200 字",
			voidDone: "已作废",
		},
		status: {
			SIGNED: "已签署",
			VOID: "已作废",
		},
		role: {
			PATIENT: "研究参与者",
			DOCTOR: "研究人员",
			GUARDIAN: "监护人",
			WITNESS: "公正见证人",
			OTHER: "其他信息",
		},
		dialog: {
			title: "签署知情同意书",
			stepTemplate: "选择模板",
			stepRead: "阅读全文",
			stepSign: "签名",
			prev: "上一步",
			next: "下一步",
			submit: "确认签署",
			selectTemplateHint: "请选择本次需要签署的知情同意书版本",
			readHint: "请与研究参与者一起阅读全文；滚动至最后一页后方可继续。",
			readEnd: "已到全文末尾",
			pageOf: "第 {n} 页 / 共 {total} 页",
			signedDate: "签署日期",
			signedDateHint: "默认为今天，可修改",
			followsSignedDate: "跟随上方签署日期",
			rangeStart: "开始时间",
			rangeEnd: "结束时间",
			noZones: "该模板尚未标注签名区域，请联系项目管理员。",
			optionalSection: "如适用",
			expand: "展开",
			collapse: "收起",
			signature: "签名",
			submitSuccess: "签署成功",
			templateLoadFailed: "模板加载失败",
			popupBlocked: "签署成功。浏览器拦截了新窗口，可在下方列表中点击「查看」打开。",
		},
		doctor: {
			stored: "已存签名",
			redraw: "重新签名",
			useStored: "使用已存签名",
			saveAsMine: "保存为我的签名",
			noStored: "您还没有保存签名，可勾选后保存本次签名。",
		},
		pad: {
			tabDraw: "手写",
			tabUpload: "上传图片",
			tabType: "输入姓名",
			drawHint: "请在下方区域内签名",
			upload: "选择图片",
			whiteToAlpha: "去除白底",
			namePlaceholder: "请输入姓名",
			undo: "撤销",
			clear: "清除",
			required: "必填",
			optional: "选填",
			imageFailed: "图片读取失败",
			notImage: "请选择图片文件",
		},
		validate: {
			signatureRequired: "请完成「{label}」签名",
			valueRequired: "请填写「{label}」",
			rangeInvalid: "「{label}」的结束时间不能早于开始时间",
		},
	},
	basicInfo: {
		doctor: "负责医生",
		maskedDoctor: "***医生",
		hospital: "所属机构",
		maskedHospital: "****医院",
		input: "请输入",
		enrollDate: "入组日期",
		select: "请选择",
		status: "入组状态",
		diagnosis: "诊断",
		diagnosisPh: "请输入诊断",
	},
	patientInfo: {
		patientNo: "患者编号",
		randomNo: "随机号",
		name: "姓名",
		gender: "性别",
		age: "年龄",
		ageUnit: "岁",
		dob: "出生日期",
		phone: "联系电话",
		idNumber: "证件号",
		project: "所属项目",
		enrollDate: "入组日期",
		status: "入组状态",
		doctor: "负责医生",
		hospital: "所属机构",
	},
	followupRecord: {
		recordTitle: "随访记录",
		newRecord: "新增随访",
		emptyHint: "暂无随访记录",
		actView: "查看",
		actEdit: "编辑",
		actDelete: "删除",
		visitName: "访视",
		dueDate: "应到日期",
		actualDate: "实际日期",
		statusPending: "未随访",
		statusOverdue: "已超窗",
		statusDone: "已随访",
		confirmCancel: "确认取消该次随访？",
		menuSelect: "模板选择",
		menuDelete: "删除模板",
		menuAdd: "新增非计划随访",
		dialogSelectTitle: "选择随访计划模板",
		dialogAddTitle: "新增非计划随访",
		fieldProjectName: "项目名称：",
		fieldTemplate: "选择模板：",
		fieldStart: "起始日期：",
		select: "请选择",
		datePh: "选择随访日期",
		ruleTemplate: "请选择模板",
		ruleStart: "请选择起始时间",
		generatePlan: "生成计划",
		confirmDelete: "删除后不可恢复，确认删除？",
		confirmDeleteOne: "确定删除该条随访记录？删除后不可恢复。",
		dialogTipTitle: "提示",
		deleteSuccess: "删除成功",
		dialogEditTitle: "编辑随访记录",
		fieldVisitName: "随访名称",
		fieldVisitType: "随访类型",
		typePlan: "计划随访",
		typeNoPlan: "非计划随访",
		fieldPlan: "随访计划",
		fieldConfig: "计划节点",
		namePh: "请输入随访名称",
		rulePlan: "请选择随访计划",
		ruleConfig: "请选择计划节点",
		editSuccess: "修改成功",
	},
	upgradation: {
		dialogTitle: "升级会员",
		selectLevel: "选择会员等级",
		level: "等级",
		duration: "时长",
		monthly: "{n}个月",
		yearly: "{n}年",
		price: "价格",
		discount: "认证用户享 5 折",
		payNow: "立即支付",
		paySuccess: "支付成功",
		payFailed: "支付失败",
		qrTip: "请使用微信扫码支付",
	},
	fileUpload: {
		click: "点击上传",
		drop: "或将文件拖到此处",
		tip: "支持 JPG / PNG / PDF",
		preview: "预览",
		download: "下载",
		remove: "删除",
		removeConfirm: "确认移除该文件？",
		uploading: "上传中…",
		uploaded: "已上传",
		uploadFailed: "上传失败",
		uploadFailedWithReason: "上传被拒绝：{reason}",
		duplicateRejected: "重复文件被拒绝——此文件已为该患者上传过。",
		exceed: "文件数量超出限制",
		view: "查看",
		upload: "上传",
		dialogUploadTitle: "上传文件",
		dialogViewTitle: "查看文件",
		cancelUpload: "取消上传",
		selectFile: "文件上传",
		dragHint: "拖拽文件至此，或",
		clickToSelect: "选择文件上传",
		aiOcr: "AI识别",
		submitted: "已提交识别",
		selectAll: "全选",
		selected: "已选 {n}",
		emptyData: "暂无数据",
	},
	patientList: {
		patientNoOrName: "患者编号/姓名：",
		enrollDate: "入组日期：",
		startDate: "开始时间",
		endDate: "结束时间",
		center: "所属中心：",
		searchPlaceholder: "请输入",
		searchKeyword: "请输入关键字",
		searchBtn: "查 询",
		resetBtn: "重 置",
		colIndex: "序号",
		colCompleteness: "完整度",
		colOperation: "操作",
		dragReorderTip: "拖动调整列顺序（仅本机生效）",
		actDetail: "患者详情",
		actFollowup: "随访详情",
		actImaging: "影像",
		actImagingWorkspace: "影像工作台",
		actTimeSeries: "时序",
		actDelete: "删除数据",
		deleteSuccess: "删除成功",
		deleteConfirm: "确认删除此患者数据？该操作不可撤销。",
		deleteTitle: "提示",
		add: "添加患者",
		export: "导出",
		batchEnroll: "批量入组",
		import: "导入",
		advancedFilter: "高级筛选",
		colPatientNo: "患者编号",
		colName: "姓名",
		colGender: "性别",
		colBirth: "出生日期",
		colAge: "年龄",
		colEnrollDate: "入组日期",
		colCenter: "所属中心",
		genderMale: "男",
		genderFemale: "女",
		genderUnknown: "未知",
		ageYears: "岁",
		viewSource: "溯源",
	},
	patientDetail: {
		add: "添加患者",
		edit: "编辑患者",
		fileView: "患者文件视图",
		basicInfo: "基本信息",
		save: "保存",
		saveDraft: "暂存",
		discard: "放弃修改",
		nextForm: "下一步",
		prevForm: "上一步",
		visitRecords: "就诊记录",
		followups: "随访记录",
		documents: "影像/文件",
		newVisit: "新增就诊",
		fieldRequired: "请输入",
	},
	retrieval: {
		title: "数据检索",
		exportTitle: "数据检索-导出",
		searchPlaceholder: "请输入关键字",
		newQuery: "新建查询",
		runQuery: "运行查询",
		exportResult: "导出结果",
		conditions: "筛选条件",
		results: "查询结果",
		colIndex: "序号",
		colName: "查询名称",
		colCreatedAt: "创建时间",
		colOperation: "操作",
		actView: "查看",
		actEdit: "编辑",
		actDelete: "删除",
		actExport: "导出",
		actRun: "运行",
		deleteGroup: "删除分组",
		selectValues: "请选择值",
		enterValue: "请输入值",
		fieldTreeFailed: "字段列表加载失败",
		selectAnalysisField: "请先选择要分析的字段",
		condition: {
			is: "等于",
			ne: "不等于",
			gt: "大于",
			gte: "大于等于",
			lt: "小于",
			lte: "小于等于",
			regex: "全部模糊匹配",
			exists: "是否存在",
			in: "在指定的数组中",
			nin: "不在指定的数组中",
			all: "数组包含所有指定的元素",
			yes: "是",
			no: "否",
			and: "符合所有条件",
			or: "符合任意条件",
			nor: "均不符合条件",
		},
		stats: {
			title: "检索结果统计",
			chart: "统计图",
			chartTypePlaceholder: "请选择分析图形",
			startDate: "开始日期",
			endDate: "结束日期",
			startDatePlaceholder: "请选择开始日期",
			endDatePlaceholder: "请选择结束日期",
			barChart: "柱状图",
			pieChart: "饼状图",
			sampleSize: "样本量",
			max: "最大值",
			min: "最小值",
			median: "中位数",
			avg: "平均数",
		},
		exportPage: {
			searchConditions: "检索条件",
			saveAsTemplate: "保存为模板",
			resultList: "检索结果列表",
			colPatientNo: "患者编号",
			colPatientName: "患者姓名",
			colEnrollmentDate: "入组日期",
			colAge: "年龄",
			colBirthday: "出生日期",
			colDoctor: "负责医生",
			colEnrollmentStatus: "入组状态",
			colLastUpdated: "最近更新日期",
			colUpdatedBy: "最近更新用户",
			colDataManage: "数据管理",
			patientDetail: "患者详情",
			followUpDetail: "随访详情",
			templateNamePlaceholder: "请输入模板名称",
			templateNameRequired: "请输入模板名称",
			templateSaved: "保存模板成功",
			joinSubProject: "入组子项目",
			existingSubProjects: "已有子项目",
			subProjectName: "子项目名称",
			projectStartDate: "项目启动日期",
			projectEndDate: "项目结束日期",
			enrolledCount: "已入组人数",
			actEnrol: "入组",
			addSubProject: "新增子项目",
			basicInfo: "基本信息",
			rootProjectName: "根项目名称",
			projectLeader: "项目负责人",
			leaderUnit: "负责人单位",
			projectGoal: "项目目标",
			selectSubProject: "请选择子项目",
			aiFilterTag: "AI 筛选",
		},
		exportDialog: {
			title: "数据导出",
			exportAll: "导出全部表单和模型",
			exportPartial: "导出部分表单和模型",
			selectForms: "请选择您要导出的表单和模型",
			approvalConfirm: "本项目导出需经审批通过后方可下载。是否提交导出申请?",
			approvalTitle: "需要审批",
			submitRequest: "提交申请",
			requestId: "申请编号",
			status: "状态",
			requestPending: "导出申请已提交,等待审核人审批。可在“我的申请”中查看进度。",
			requestSubmitted: "导出申请已提交",
			goToMyRequests: "前往我的申请",
		},
		aiFilter: {
			history: "历史对话",
			newChat: "+ 新对话",
			noConversations: "暂无历史对话",
			untitled: "未命名",
			matchedTag: "命中 {n}",
			emptyIntro: "用一段话描述筛选要求——AI 会在项目最新数据快照上编写并执行筛选代码。",
			emptyIntroSub: "可以随时追加消息细化条件；遇到会显著影响结果的口径分叉时，AI 会向你提问而不是擅自决定。每轮一般需要 1~5 分钟。",
			optCount: "{n} 例",
			letAiDecide: "让 AI 自行决定",
			turnMatched: "本轮命中 {n} 例患者",
			viewResult: "查看结果 →",
			ctrlEnterHint: "Ctrl+Enter 发送",
			working: "执行中…",
			send: "发送",
			resultPlaceholder: "最新一轮的筛选结果会显示在这里。",
			matchedPatients: "匹配 {n} 例患者",
			totalInProject: "项目共 {n} 例",
			criteriaFunnel: "条件命中漏斗",
			colCriterion: "筛选条件",
			colStandalone: "单独命中",
			colCumulative: "累计命中",
			expansionSuggestions: "扩大范围建议",
			estimatedAdditional: "预计+{n}例",
			applySuggestion: "采纳并重新筛选",
			samplesLabel: "样例：",
			exportExcel: "导出 Excel",
			exportDataset: "导出为分析数据集",
			startResearch: "开始研究分析",
			confirmAndView: "确认并查看结果",
			datasetDialogTitle: "导出为分析数据集",
			datasetName: "数据集名称",
			datasetHint: "将把命中患者拍平为每人一行的宽表数据集，并登记到「研究资料」库中，可直接在分析工作台使用。",
			datasetCreated: "数据集已创建",
			create: "创建",
			openLibrary: "前往研究资料库",
			retry: "重试",
			followUpPlaceholder: "继续对话：细化条件、回答上面的问题，或要求扩大/缩小范围…",
			examplePlaceholder: "例如：诊断为缺血性卒中（大动脉粥样硬化型或心源性栓塞型）、既往有高血压或糖尿病史，并且（任一次随访收缩压大于150，或基线NIHSS评分≥10）的患者",
			exportingSnapshot: "正在导出数据快照 {docs}/{total}…",
			filterFailed: "AI 筛选失败",
			starting: "正在启动…",
			runInProgress: "已有一个 AI 筛选正在运行，请稍候",
			noProjectAccess: "无权在当前项目执行 AI 筛选",
			conversationGone: "对话不存在或已被删除",
			filterRunFailed: "AI 筛选执行失败",
			cancelled: "已取消",
			autoDecidePrompt: "你决定——按临床上最合理的默认口径继续执行，这个问题不用再问。",
			adjustmentPrefix: "补充调整：",
			replayMatched: "**本轮命中 {n} 例患者。**",
			conversationDataGone: "该对话的数据已不可恢复",
			openConversationFailed: "打开对话失败",
			deleteConversationConfirm: "删除「{title}」？云端保存的副本也会一并删除。",
			deleteConversationTitle: "删除对话",
			deleteFailed: "删除失败",
			matchesDisplayName: "AI筛选命中患者",
			startResearchFailed: "启动研究分析失败",
			sessionExpiredExport: "登录已过期，请重新登录后再导出",
			exportInProgress: "已有一个导出正在进行，请稍候",
			excelExportFailed: "Excel 导出失败，请稍后重试",
			datasetNamePrefix: "AI筛选",
			datasetResult: "{name}：{rows} 名患者，{cols} 列",
			datasetExportFailed: "数据集导出失败",
			datasetExportInProgress: "已有一个数据集导出正在进行，请稍候",
			datasetExportStartFailed: "数据集导出启动失败",
			excelFilenamePrefix: "AI筛选",
		},
		savedSearches: "常用搜索",
		pickTemplatePlaceholder: "请选择模板",
		group: "组合",
		clearAll: "一键清空",
		addOrPickCondition: "请添加或选择搜索条件",
		fieldNamePlaceholder: "输入检索字段的名称",
		aiFilterTab: "AI 筛选",
	},
	analysis: {
		title: "数据分析",
		runAnalysis: "执行分析",
		results: "分析结果",
		exportResult: "导出报告",
		emptyHint: "请先选择字段并执行分析",
	},
	projectManage: {
		title: "项目列表",
		searchPlaceholder: "请输入项目名称",
		clearModelCache: "清除模型缓存",
		clearModelCacheConfirm: "确认清除所有模型缓存？清除后所有用户首次加载会稍慢。",
		clearModelCacheTip: "提示",
		clearModelCacheSuccess: "缓存已清除，共清除 {n} 条缓存",
		newProject: "新建项目",
		colProjectId: "项目ID",
		colProjectName: "项目名称",
		colProjectLeader: "项目负责人",
		colProjectTerm: "项目周期",
		colFollowupData: "随访数据",
		colViewInfo: "视图信息",
		colMainCenter: "主中心",
		colOperation: "操作",
		actEdit: "编辑项目",
		actScene: "应用场景",
		actDatabase: "数据库配置",
		actFollowup: "随访设置",
		actPermissions: "人员权限",
		actSubCenter: "分中心管理",
		actSubProject: "子项目管理",
		actSchema: "架构初始生成",
		actAgent: "Agent配置",
		actMetadataHistory: "元数据历史",
		actLifecycle: "生命周期与留存",
		actPiiRule: "PII规则配置",
		actConsent: "知情同意书",
		grpSetup: "设置",
		grpData: "数据",
		grpGovernance: "治理",
		grpStructure: "结构",
		lostFollowups: "丟失计划随访条数 {n}",
		fixData: "修复数据",
		patientCount: "就诊人:{p} ; 视图行: {v};",
		patientViewMismatch: "---存在差异---",
		buildStatus: "构建状态:{s} ;",
		buildBusy: "视图构件中",
		buildIdle: "当前无任务",
		startTime: "开始时间:{t};",
		endTime: "结束时间:{t};",
		execResult: "执行结果:{r};",
		execSuccess: "成功",
		execFailed: "失败",
		rebuildView: "重建视图",
		appendView: "修补视图",
		recalcCompleteness: "重算完整度",
		opSent: "请求已发送",
		recalcDone: "重算完成，共处理 {n} 位患者",
		dialogBaseTitle: "基本信息",
		dialogSceneTitle: "应用场景",
		fieldProjectName: "项目名称",
		fieldProjectCode: "项目编码",
		fieldProjectLeader: "项目负责人",
		fieldLeadCenter: "牵头单位",
		fieldStartDate: "项目启动日期",
		fieldEndDate: "项目结束日期",
		fieldTarget: "项目目标",
		fieldLeaderUnit: "负责人单位",
		fieldCompanyLogo: "公司Logo（横版）",
		fieldSquareLogo: "方形Logo（图标）",
		placeholderSelect: "请选择",
		fieldSpecialty: "专科",
		fieldDisease: "疾病",
		fieldSoftwareEnv: "软件环境",
		envWeb: "web",
		envDoctor: "医生小程序",
		envPatient: "患者小程序",
		fieldLoginUrl: "项目登录页URL",
		fieldLoginName: "项目登录页名称",
		fieldLoginImage: "项目登录页图片",
		searchPlaceholderRemote: "请输入关键字",
	},
	equity: {
		accountInfo: "账号信息",
		username: "用户名：",
		realNameAuth: "实名认证：",
		modify: "修改",
		notAuthHint: "当前您未完成信息认证，无法享受五折优惠",
		goAuth: "去认证",
		levelExpire: "会员等级有效期：{date}",
		upgrade: "去升级会员",
		memberRights: "会员权益",
		categoryProjectMgmt: "项目管理",
		categoryAiCollect: "AI数据采集功能",
		categoryAiAnalysis: "AI数据分析功能",
		categoryIp: "知识产权服务",
		categoryResearch: "科研项目服务",
		rightCreateProject: "新建项目",
		rightCustomForm: "自定义表单",
		rightFollowup: "随访管理",
		rightEnrollment: "入组状态管理",
		rightSubProject: "子项目管理",
		rightUnivariate: "单变量统计",
		rightSearch: "数据检索",
		rightExport: "数据导出",
		rightHistorical: "历史数据入组新项目",
		rightAutoEnroll: "新数据自动纳排",
		rightCrfGen: "自动生成CRF表",
		rightCrfFill: "自动填充CRF表",
		rightPathology: "自动生成病理报告",
		rightFollowupChat: "交互式患者随访",
		rightAiSearch: "AI数据检索",
		rightAiStat: "AI数据统计",
		rightAiExport: "AI数据筛选导出",
		rightAiEnroll: "AI纳排管理",
		rightIpFile: "知识产权申报",
		rightJointProject: "联合项目申报",
		basicMember: "基础会员",
		smartMember: "智慧会员",
		joint1Software: "免费申请联合软著1项",
		joint2Software: "免费申请独立软著2项",
		jointAiProject: "可联合申报医疗人工智能项目",
		currentLevel: "当前等级",
		dialogAuthTitle: "信息认证",
	},
	order: {
		searchPlaceholder: "请输入订单编号",
		orderList: "订单列表",
		colIndex: "序号",
		colOrderNo: "订单号",
		colPaymentTime: "交易时间",
		colPaymentFees: "交易金额",
		colPaymentMethod: "支付方式",
		methodWechat: "微信",
		colContent: "交易内容",
		colStatus: "当前状态",
		colInvoiceStatus: "开票状态",
		colOperation: "操作",
		actInvoice: "开票",
		statusCreated: "待支付",
		statusPayed: "已支付",
		statusUsed: "已使用",
		invoiceNotIssued: "未开票",
		invoiceIssued: "已开票",
		dialogTitle: "填写开票信息",
		titleSection: "抬头信息",
		fieldAmount: "发票金额",
		amountUnit: "元",
		fieldHeaderType: "抬头类型",
		typePersonal: "个人/非企业单位",
		typeEnterprise: "企业",
		fieldInvoiceType: "发票类型",
		invoiceTypeValue: "增值税普通电子发票",
		fieldHeader: "发票抬头",
		placeholderInput: "请输入",
		placeholderHeader: "请输入发票抬头",
		fieldTaxNumber: "纳税人识别号",
		placeholderTaxNumber: "请输入15-20位的纳税人识别号",
	},
	subProjectManage: {
		title: "子项目列表",
		breadCrumb: "项目管理 / {parent}",
		newSubProject: "新建子项目",
		searchPlaceholder: "请输入子项目名称",
	},
	projectList: {
		projectCode: "项目编码",
		centerCount: "中心数量",
		patientCount: "入组患者数量",
		subProjects: "子项目列表",
		openProject: "进入项目",
		emptyHint: "您还没有任何项目，快去创建一个项目吧～",
		createProject: "创建项目",
		noticeSystem: "系统通知",
		noticeOcr: "OCR识别",
		noticeChallenge: "数据质疑",
	},
	projectHead: {
		projectName: "项目名称",
		rootProjectName: "根项目名称",
		subProjectName: "子项目名称",
		parentProject: "关联队列项目",
		specialty: "关联专科",
		disease: "关联疾病",
		formConfig: "表单配置",
		followUpConfig: "随访配置",
		schemaSnapshot: "架构快照",
	},
	home: {
		leadCentre: "牵头单位",
		maskedHospital: "****医院",
		projectLead: "项目负责人",
		projectTerm: "项目期限",
		pendingReply: "待回复问诊",
		clickToReply: "点击查看并回复 →",
		totalCases: "病例总数",
		newCasesThisMonth: "本月新增病例",
		avgCompleteness: "平均完整度",
		followUpOverdue: "随访超窗",
		view: "查看",
		notifications: "项目通知",
		index: "序号",
		notificationType: "通知类型",
		notificationContent: "通知内容",
		count: "人数",
		enrollmentTrend: "入组情况",
		genderRatio: "男女比例",
		ageDistribution: "年龄分布",
	},
};
